// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';
// // // // // import PremiumFooter from './Footer';

// // // // // const InteriorDesignWebsite = () => {
// // // // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // // // //   const [currentSlide, setCurrentSlide] = useState(0);
// // // // //   const [scrollY, setScrollY] = useState(0);

// // // // //   useEffect(() => {
// // // // //     const handleScroll = () => setScrollY(window.scrollY);
// // // // //     window.addEventListener('scroll', handleScroll);
// // // // //     return () => window.removeEventListener('scroll', handleScroll);
// // // // //   }, []);

// // // // //   const heroSlides = [
// // // // //     {
// // // // //       image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
// // // // //       title: "Luxury Living Redefined",
// // // // //       subtitle: "Crafting extraordinary spaces that inspire and elevate"
// // // // //     },
// // // // //     {
// // // // //       image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
// // // // //       title: "Modern Sophistication",
// // // // //       subtitle: "Where contemporary design meets timeless elegance"
// // // // //     },
// // // // //     {
// // // // //       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
// // // // //       title: "Architectural Excellence",
// // // // //       subtitle: "Transforming visions into breathtaking realities"
// // // // //     }
// // // // //   ];

// // // // //   const services = [
// // // // //     {
// // // // //       icon: <Home className="w-8 h-8" />,
// // // // //       title: "Residential Design",
// // // // //       description: "Complete home transformations with personalized luxury touches",
// // // // //       features: ["Custom Furniture", "Space Planning", "Color Consultation"]
// // // // //     },
// // // // //     {
// // // // //       icon: <Award className="w-8 h-8" />,
// // // // //       title: "Commercial Spaces",
// // // // //       description: "Innovative workplace and retail environments that inspire",
// // // // //       features: ["Office Design", "Retail Spaces", "Hospitality"]
// // // // //     },
// // // // //     {
// // // // //       icon: <Users className="w-8 h-8" />,
// // // // //       title: "Consultation",
// // // // //       description: "Expert guidance from concept to completion",
// // // // //       features: ["Design Strategy", "Project Management", "Styling Services"]
// // // // //     }
// // // // //   ];

// // // // //   const portfolio = [
// // // // //     {
// // // // //       id: 1,
// // // // //       title: "Manhattan Penthouse",
// // // // //       category: "Residential",
// // // // //       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop",
// // // // //       description: "A sophisticated urban retreat with panoramic city views"
// // // // //     },
// // // // //     {
// // // // //       id: 2,
// // // // //       title: "Modern Office Complex",
// // // // //       category: "Commercial",
// // // // //       image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
// // // // //       description: "Innovative workspace design promoting creativity and collaboration"
// // // // //     },
// // // // //     {
// // // // //       id: 3,
// // // // //       title: "Luxury Resort Suite",
// // // // //       category: "Hospitality",
// // // // //       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
// // // // //       description: "Elegant coastal design with natural materials and textures"
// // // // //     },
// // // // //     {
// // // // //       id: 4,
// // // // //       title: "Contemporary Villa",
// // // // //       category: "Residential",
// // // // //       image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
// // // // //       description: "Minimalist luxury with seamless indoor-outdoor living"
// // // // //     }
// // // // //   ];

// // // // //   useEffect(() => {
// // // // //     const interval = setInterval(() => {
// // // // //       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
// // // // //     }, 5000);
// // // // //     return () => clearInterval(interval);
// // // // //   }, []);

// // // // //   return (
// // // // //     <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
// // // // //       {/* Load Fonts */}
// // // // //       <link
// // // // //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// // // // //         rel="stylesheet"
// // // // //       />

// // // // //       {/* Navigation */}
    

// // // // //       {/* Hero Section */}
// // // // //       <section id="home" className="relative h-screen overflow-hidden">
// // // // //         {/* Background Slides */}
// // // // //         {heroSlides.map((slide, index) => (
// // // // //           <div
// // // // //             key={index}
// // // // //             className={`absolute inset-0 transition-all duration-1000 ${
// // // // //               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
// // // // //             }`}
// // // // //           >
// // // // //             <img
// // // // //               src={slide.image}
// // // // //               alt={slide.title}
// // // // //               className="w-full h-full object-cover"
// // // // //             />
// // // // //             <div className="absolute inset-0 bg-stone-900/40"></div>
// // // // //           </div>
// // // // //         ))}

// // // // //         {/* Content */}
// // // // //         <div className="relative z-10 h-full flex items-center justify-center">
// // // // //           <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
// // // // //             <div 
// // // // //               className="transform transition-all duration-1000 delay-300"
// // // // //               style={{
// // // // //                 transform: `translateY(${scrollY * 0.3}px)`,
// // // // //               }}
// // // // //             >
// // // // //               <h1 
// // // // //                 className="text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
// // // // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // // // //               >
// // // // //                 {heroSlides[currentSlide].title}
// // // // //               </h1>
// // // // //               <p className="text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
// // // // //                 {heroSlides[currentSlide].subtitle}
// // // // //               </p>
// // // // //               <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
// // // // //                 <button className="group bg-stone-50 text-stone-900 px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold">
// // // // //                   <span className="flex items-center gap-2">
// // // // //                     Explore Portfolio
// // // // //                     <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// // // // //                   </span>
// // // // //                 </button>
// // // // //                 <button className="group border-2 border-stone-50 text-stone-50 px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold">
// // // // //                   <span className="flex items-center gap-2">
// // // // //                     <Play className="w-5 h-5" />
// // // // //                     Watch Video
// // // // //                   </span>
// // // // //                 </button>
// // // // //               </div>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>

// // // // //         {/* Slide Indicators */}
// // // // //         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
// // // // //           {heroSlides.map((_, index) => (
// // // // //             <button
// // // // //               key={index}
// // // // //               onClick={() => setCurrentSlide(index)}
// // // // //               className={`w-3 h-3 rounded-full transition-all duration-300 ${
// // // // //                 index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
// // // // //               }`}
// // // // //             />
// // // // //           ))}
// // // // //         </div>

// // // // //         {/* Scroll Indicator */}
// // // // //         <div className="absolute bottom-8 right-8 animate-bounce">
// // // // //           <ChevronDown className="w-8 h-8 text-stone-50" />
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* Services Section */}
// // // // //       <section id="services" className="py-20 bg-stone-50">
// // // // //         <div className="max-w-7xl mx-auto px-6">
// // // // //           <div className="text-center mb-16">
// // // // //             <h2 
// // // // //               className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // // //               style={{fontFamily: "'Playfair Display', serif"}}
// // // // //             >
// // // // //               Our Services
// // // // //             </h2>
// // // // //             <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // // // //               From concept to completion, we deliver exceptional interior design solutions 
// // // // //               tailored to your unique vision and lifestyle.
// // // // //             </p>
// // // // //           </div>

// // // // //           <div className="grid md:grid-cols-3 gap-8">
// // // // //             {services.map((service, index) => (
// // // // //               <div
// // // // //                 key={index}
// // // // //                 className="group bg-stone-100 p-8 rounded-2xl hover:bg-stone-900 transition-all duration-700 transform hover:scale-105 hover:-translate-y-2"
// // // // //               >
// // // // //                 <div className="text-stone-900 group-hover:text-stone-50 mb-6 transition-colors duration-500">
// // // // //                   {service.icon}
// // // // //                 </div>
// // // // //                 <h3 className="text-2xl font-bold mb-4 text-stone-900 group-hover:text-stone-50 transition-colors duration-500">
// // // // //                   {service.title}
// // // // //                 </h3>
// // // // //                 <p className="text-stone-600 group-hover:text-stone-200 mb-6 transition-colors duration-500">
// // // // //                   {service.description}
// // // // //                 </p>
// // // // //                 <ul className="space-y-2">
// // // // //                   {service.features.map((feature, idx) => (
// // // // //                     <li key={idx} className="text-stone-500 group-hover:text-stone-300 transition-colors duration-500 flex items-center">
// // // // //                       <span className="w-2 h-2 bg-stone-400 group-hover:bg-stone-300 rounded-full mr-3 transition-colors duration-500"></span>
// // // // //                       {feature}
// // // // //                     </li>
// // // // //                   ))}
// // // // //                 </ul>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* Portfolio Section */}
// // // // //       <section id="portfolio" className="py-20 bg-stone-100">
// // // // //         <div className="max-w-7xl mx-auto px-6">
// // // // //           <div className="text-center mb-16">
// // // // //             <h2 
// // // // //               className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // // //               style={{fontFamily: "'Playfair Display', serif"}}
// // // // //             >
// // // // //               Featured Projects
// // // // //             </h2>
// // // // //             <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // // // //               Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
// // // // //             </p>
// // // // //           </div>

// // // // //           <div className="grid md:grid-cols-2 gap-8">
// // // // //             {portfolio.map((project, index) => (
// // // // //               <div
// // // // //                 key={project.id}
// // // // //                 className="group relative overflow-hidden rounded-3xl bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02]"
// // // // //               >
// // // // //                 <img
// // // // //                   src={project.image}
// // // // //                   alt={project.title}
// // // // //                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// // // // //                 />
// // // // //                 <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// // // // //                 <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
// // // // //                   <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
// // // // //                     {project.category}
// // // // //                   </span>
// // // // //                   <h3 className="text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
// // // // //                     {project.title}
// // // // //                   </h3>
// // // // //                   <p className="text-stone-200 mb-4">{project.description}</p>
// // // // //                   <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
// // // // //                     View Project <ArrowRight className="w-5 h-5" />
// // // // //                   </button>
// // // // //                 </div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* Stats Section */}
// // // // //       <section className="py-20 bg-stone-900 text-stone-50">
// // // // //         <div className="max-w-7xl mx-auto px-6">
// // // // //           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
// // // // //             {[
// // // // //               { number: "150+", label: "Projects Completed" },
// // // // //               { number: "50+", label: "Happy Clients" },
// // // // //               { number: "15+", label: "Years Experience" },
// // // // //               { number: "25+", label: "Design Awards" }
// // // // //             ].map((stat, index) => (
// // // // //               <div key={index} className="text-center">
// // // // //                 <div 
// // // // //                   className="text-4xl md:text-5xl font-bold mb-2"
// // // // //                   style={{fontFamily: "'Playfair Display', serif"}}
// // // // //                 >
// // // // //                   {stat.number}
// // // // //                 </div>
// // // // //                 <div className="text-stone-300 font-medium">{stat.label}</div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* CTA Section */}
// // // // //       <section className="py-20 bg-stone-50">
// // // // //         <div className="max-w-4xl mx-auto text-center px-6">
// // // // //           <h2 
// // // // //             className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // // //             style={{fontFamily: "'Playfair Display', serif"}}
// // // // //           >
// // // // //             Ready to Transform Your Space?
// // // // //           </h2>
// // // // //           <p className="text-xl text-stone-600 mb-8 max-w-2xl mx-auto">
// // // // //             Let's create something extraordinary together. Contact us today to begin your design journey.
// // // // //           </p>
// // // // //           <div className="flex flex-col sm:flex-row gap-4 justify-center">
// // // // //             <button className="group bg-stone-900 text-stone-50 px-8 py-4 rounded-full hover:bg-stone-800 transition-all duration-300 transform hover:scale-105 font-semibold">
// // // // //               <span className="flex items-center gap-2">
// // // // //                 Start Your Project
// // // // //                 <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// // // // //               </span>
// // // // //             </button>
// // // // //             <button className="border-2 border-stone-900 text-stone-900 px-8 py-4 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-300 transform hover:scale-105 font-semibold">
// // // // //               Schedule Consultation
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* Footer */}
// // // // //     <PremiumFooter/>

// // // // //       <style jsx>{`
// // // // //         @keyframes slideUp {
// // // // //           from {
// // // // //             opacity: 0;
// // // // //             transform: translateY(50px);
// // // // //           }
// // // // //           to {
// // // // //             opacity: 1;
// // // // //             transform: translateY(0);
// // // // //           }
// // // // //         }
// // // // //       `}</style>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default InteriorDesignWebsite;



// // // // import React, { useState, useEffect, useRef } from 'react';
// // // // import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';

// // // // // Reusable RevealImage Component
// // // // const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
// // // //   const wrapperRef = useRef();
// // // //   useEffect(() => {
// // // //     const el = wrapperRef.current;
// // // //     const observer = new IntersectionObserver(
// // // //       entries => {
// // // //         entries.forEach(entry => {
// // // //           if (entry.isIntersecting) {
// // // //             el.classList.add("revealed");
// // // //             observer.unobserve(el);
// // // //           }
// // // //         });
// // // //       },
// // // //       { threshold: 0.3 }
// // // //     );
// // // //     if (el) observer.observe(el);
// // // //     return () => {
// // // //       if (el) observer.unobserve(el);
// // // //     };
// // // //   }, []);
  
// // // //   return (
// // // //     <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
// // // //       <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
// // // //       <div className="reveal-mask"></div>
// // // //     </div>
// // // //   );
// // // // };

// // // // const InteriorDesignWebsite = () => {
// // // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // // //   const [currentSlide, setCurrentSlide] = useState(0);
// // // //   const [scrollY, setScrollY] = useState(0);
// // // //   const [isVisible, setIsVisible] = useState({});

// // // //   useEffect(() => {
// // // //     const handleScroll = () => setScrollY(window.scrollY);
// // // //     window.addEventListener('scroll', handleScroll);
// // // //     return () => window.removeEventListener('scroll', handleScroll);
// // // //   }, []);

// // // //   // Intersection Observer for scroll animations
// // // //   useEffect(() => {
// // // //     const observer = new IntersectionObserver(
// // // //       (entries) => {
// // // //         entries.forEach((entry) => {
// // // //           if (entry.isIntersecting) {
// // // //             setIsVisible(prev => ({
// // // //               ...prev,
// // // //               [entry.target.id]: true
// // // //             }));
// // // //           }
// // // //         });
// // // //       },
// // // //       { 
// // // //         threshold: 0.1,
// // // //         rootMargin: '0px 0px -50px 0px'
// // // //       }
// // // //     );

// // // //     const elements = document.querySelectorAll('[data-animate]');
// // // //     elements.forEach((el) => observer.observe(el));

// // // //     return () => observer.disconnect();
// // // //   }, []);

// // // //   const heroSlides = [
// // // //     {
// // // //       image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
// // // //       title: "Luxury Living Redefined",
// // // //       subtitle: "Crafting extraordinary spaces that inspire and elevate"
// // // //     },
// // // //     {
// // // //       image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
// // // //       title: "Modern Sophistication",
// // // //       subtitle: "Where contemporary design meets timeless elegance"
// // // //     },
// // // //     {
// // // //       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
// // // //       title: "Architectural Excellence",
// // // //       subtitle: "Transforming visions into breathtaking realities"
// // // //     }
// // // //   ];

// // // //   const services = [
// // // //     {
// // // //       icon: <Home className="w-8 h-8" />,
// // // //       title: "Residential Design",
// // // //       description: "Complete home transformations with personalized luxury touches",
// // // //       features: ["Custom Furniture", "Space Planning", "Color Consultation"]
// // // //     },
// // // //     {
// // // //       icon: <Award className="w-8 h-8" />,
// // // //       title: "Commercial Spaces",
// // // //       description: "Innovative workplace and retail environments that inspire",
// // // //       features: ["Office Design", "Retail Spaces", "Hospitality"]
// // // //     },
// // // //     {
// // // //       icon: <Users className="w-8 h-8" />,
// // // //       title: "Consultation",
// // // //       description: "Expert guidance from concept to completion",
// // // //       features: ["Design Strategy", "Project Management", "Styling Services"]
// // // //     }
// // // //   ];

// // // //   const portfolio = [
// // // //     {
// // // //       id: 1,
// // // //       title: "Manhattan Penthouse",
// // // //       category: "Residential",
// // // //       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop",
// // // //       description: "A sophisticated urban retreat with panoramic city views"
// // // //     },
// // // //     {
// // // //       id: 2,
// // // //       title: "Modern Office Complex",
// // // //       category: "Commercial",
// // // //       image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
// // // //       description: "Innovative workspace design promoting creativity and collaboration"
// // // //     },
// // // //     {
// // // //       id: 3,
// // // //       title: "Luxury Resort Suite",
// // // //       category: "Hospitality",
// // // //       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
// // // //       description: "Elegant coastal design with natural materials and textures"
// // // //     },
// // // //     {
// // // //       id: 4,
// // // //       title: "Contemporary Villa",
// // // //       category: "Residential",
// // // //       image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
// // // //       description: "Minimalist luxury with seamless indoor-outdoor living"
// // // //     }
// // // //   ];

// // // //   useEffect(() => {
// // // //     const interval = setInterval(() => {
// // // //       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
// // // //     }, 5000);
// // // //     return () => clearInterval(interval);
// // // //   }, []);

// // // //   return (
// // // //     <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
// // // //       {/* Load Fonts */}
// // // //       <link
// // // //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// // // //         rel="stylesheet"
// // // //       />

// // // //       {/* Global CSS for smooth scrolling and hidden scrollbars */}
// // // //       <style jsx global>{`
// // // //         html {
// // // //           scroll-behavior: smooth;
// // // //         }
        
// // // //         /* Hide scrollbars completely */
// // // //         ::-webkit-scrollbar {
// // // //           width: 0px;
// // // //           background: transparent;
// // // //         }
        
// // // //         body {
// // // //           scrollbar-width: none;
// // // //           -ms-overflow-style: none;
// // // //           overflow-x: hidden;
// // // //         }
        
// // // //         /* Smooth scroll momentum */
// // // //         * {
// // // //           -webkit-overflow-scrolling: touch;
// // // //         }
// // // //       `}</style>

// // // //       {/* Enhanced animations matching About page style */}
// // // //       <style jsx>{`
// // // //         /* RevealImage Effects */
// // // //         .reveal-wrapper {
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //         }
        
// // // //         .reveal-wrapper .reveal-mask {
// // // //           position: absolute;
// // // //           top: 0;
// // // //           left: 0;
// // // //           width: 100%;
// // // //           height: 100%;
// // // //           background: #f3f4f6;
// // // //           transform: translateX(-100%);
// // // //           transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //           z-index: 2;
// // // //         }
        
// // // //         .reveal-wrapper.revealed .reveal-mask {
// // // //           transform: translateX(100%);
// // // //         }
        
// // // //         .reveal-wrapper img {
// // // //           opacity: 0;
// // // //           transform: scale(1.1);
// // // //           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //         }
        
// // // //         .reveal-wrapper.revealed img {
// // // //           opacity: 1;
// // // //           transform: scale(1);
// // // //         }
        
// // // //         /* Scroll Animations */
// // // //         .fade-up {
// // // //           opacity: 0;
// // // //           transform: translateY(50px);
// // // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //         }
        
// // // //         .fade-up.visible {
// // // //           opacity: 1;
// // // //           transform: translateY(0);
// // // //         }
        
// // // //         .fade-left {
// // // //           opacity: 0;
// // // //           transform: translateX(-50px);
// // // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //         }
        
// // // //         .fade-left.visible {
// // // //           opacity: 1;
// // // //           transform: translateX(0);
// // // //         }
        
// // // //         .fade-right {
// // // //           opacity: 0;
// // // //           transform: translateX(50px);
// // // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //         }
        
// // // //         .fade-right.visible {
// // // //           opacity: 1;
// // // //           transform: translateX(0);
// // // //         }
        
// // // //         .zoom-in {
// // // //           opacity: 0;
// // // //           transform: scale(0.9);
// // // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // // //         }
        
// // // //         .zoom-in.visible {
// // // //           opacity: 1;
// // // //           transform: scale(1);
// // // //         }

// // // //         @keyframes slideUp {
// // // //           from {
// // // //             opacity: 0;
// // // //             transform: translateY(50px);
// // // //           }
// // // //           to {
// // // //             opacity: 1;
// // // //             transform: translateY(0);
// // // //           }
// // // //         }
// // // //       `}</style>

// // // //       {/* Navigation */}
    

// // // //       {/* Hero Section */}
// // // //       <section id="home" className="relative h-screen overflow-hidden">
// // // //         {/* Background Slides */}
// // // //         {heroSlides.map((slide, index) => (
// // // //           <div
// // // //             key={index}
// // // //             className={`absolute inset-0 transition-all duration-1000 ${
// // // //               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
// // // //             }`}
// // // //           >
// // // //             <img
// // // //               src={slide.image}
// // // //               alt={slide.title}
// // // //               className="w-full h-full object-cover"
// // // //             />
// // // //             <div className="absolute inset-0 bg-stone-900/40"></div>
// // // //           </div>
// // // //         ))}

// // // //         {/* Content */}
// // // //         <div className="relative z-10 h-full flex items-center justify-center">
// // // //           <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
// // // //             <div 
// // // //               className="transform transition-all duration-1000 delay-300"
// // // //               style={{
// // // //                 transform: `translateY(${scrollY * 0.3}px)`,
// // // //               }}
// // // //             >
// // // //               <h1 
// // // //                 className="text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
// // // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // // //               >
// // // //                 {heroSlides[currentSlide].title}
// // // //               </h1>
// // // //               <p className="text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
// // // //                 {heroSlides[currentSlide].subtitle}
// // // //               </p>
// // // //               <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
// // // //                 <button className="group bg-stone-50 text-stone-900 px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold">
// // // //                   <span className="flex items-center gap-2">
// // // //                     Explore Portfolio
// // // //                     <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// // // //                   </span>
// // // //                 </button>
// // // //                 <button className="group border-2 border-stone-50 text-stone-50 px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold">
// // // //                   <span className="flex items-center gap-2">
// // // //                     <Play className="w-5 h-5" />
// // // //                     Watch Video
// // // //                   </span>
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>

// // // //         {/* Slide Indicators */}
// // // //         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
// // // //           {heroSlides.map((_, index) => (
// // // //             <button
// // // //               key={index}
// // // //               onClick={() => setCurrentSlide(index)}
// // // //               className={`w-3 h-3 rounded-full transition-all duration-300 ${
// // // //                 index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
// // // //               }`}
// // // //             />
// // // //           ))}
// // // //         </div>

// // // //         {/* Scroll Indicator */}
// // // //         <div className="absolute bottom-8 right-8 animate-bounce">
// // // //           <ChevronDown className="w-8 h-8 text-stone-50" />
// // // //         </div>
// // // //       </section>

// // // //       {/* Services Section */}
// // // //       <section id="services" className="py-20 bg-stone-50">
// // // //         <div className="max-w-7xl mx-auto px-6">
// // // //           <div data-animate id="services-header">
// // // //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['services-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               <h2 
// // // //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // // //               >
// // // //                 Our Services
// // // //               </h2>
// // // //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // // //                 From concept to completion, we deliver exceptional interior design solutions 
// // // //                 tailored to your unique vision and lifestyle.
// // // //               </p>
// // // //             </div>
// // // //           </div>

// // // //           <div data-animate id="services-grid">
// // // //             <div className={`grid md:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ${isVisible['services-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               {services.map((service, index) => (
// // // //                 <div
// // // //                   key={index}
// // // //                   className={`group bg-stone-100 p-8 rounded-2xl hover:bg-stone-900 transition-all duration-700 transform hover:scale-105 hover:-translate-y-2 fade-up ${isVisible['services-grid'] ? 'visible' : ''}`}
// // // //                   style={{ transitionDelay: `${index * 200}ms` }}
// // // //                 >
// // // //                   <div className="text-stone-900 group-hover:text-stone-50 mb-6 transition-colors duration-500">
// // // //                     {service.icon}
// // // //                   </div>
// // // //                   <h3 className="text-2xl font-bold mb-4 text-stone-900 group-hover:text-stone-50 transition-colors duration-500">
// // // //                     {service.title}
// // // //                   </h3>
// // // //                   <p className="text-stone-600 group-hover:text-stone-200 mb-6 transition-colors duration-500">
// // // //                     {service.description}
// // // //                   </p>
// // // //                   <ul className="space-y-2">
// // // //                     {service.features.map((feature, idx) => (
// // // //                       <li key={idx} className="text-stone-500 group-hover:text-stone-300 transition-colors duration-500 flex items-center">
// // // //                         <span className="w-2 h-2 bg-stone-400 group-hover:bg-stone-300 rounded-full mr-3 transition-colors duration-500"></span>
// // // //                         {feature}
// // // //                       </li>
// // // //                     ))}
// // // //                   </ul>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* Portfolio Section */}
// // // //       <section id="portfolio" className="py-20 bg-stone-100">
// // // //         <div className="max-w-7xl mx-auto px-6">
// // // //           <div data-animate id="portfolio-header">
// // // //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               <h2 
// // // //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // // //               >
// // // //                 Featured Projects
// // // //               </h2>
// // // //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // // //                 Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
// // // //               </p>
// // // //             </div>
// // // //           </div>

// // // //           <div data-animate id="portfolio-grid">
// // // //             <div className={`grid md:grid-cols-2 gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               {portfolio.map((project, index) => (
// // // //                 <div
// // // //                   key={project.id}
// // // //                   className={`group relative overflow-hidden rounded-3xl bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
// // // //                   style={{ transitionDelay: `${index * 200}ms` }}
// // // //                 >
// // // //                   <RevealImage
// // // //                     src={project.image}
// // // //                     alt={project.title}
// // // //                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// // // //                   />
// // // //                   <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// // // //                   <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
// // // //                     <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
// // // //                       {project.category}
// // // //                     </span>
// // // //                     <h3 className="text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
// // // //                       {project.title}
// // // //                     </h3>
// // // //                     <p className="text-stone-200 mb-4">{project.description}</p>
// // // //                     <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
// // // //                       View Project <ArrowRight className="w-5 h-5" />
// // // //                     </button>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* Stats Section */}
// // // //       <section className="py-20 bg-stone-900 text-stone-50">
// // // //         <div className="max-w-7xl mx-auto px-6">
// // // //           <div data-animate id="stats-section">
// // // //             <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 transition-all duration-1000 ${isVisible['stats-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               {[
// // // //                 { number: "150+", label: "Projects Completed" },
// // // //                 { number: "50+", label: "Happy Clients" },
// // // //                 { number: "15+", label: "Years Experience" },
// // // //                 { number: "25+", label: "Design Awards" }
// // // //               ].map((stat, index) => (
// // // //                 <div 
// // // //                   key={index} 
// // // //                   className={`text-center fade-up ${isVisible['stats-section'] ? 'visible' : ''}`}
// // // //                   style={{ transitionDelay: `${index * 200}ms` }}
// // // //                 >
// // // //                   <div 
// // // //                     className="text-4xl md:text-5xl font-bold mb-2"
// // // //                     style={{fontFamily: "'Playfair Display', serif"}}
// // // //                   >
// // // //                     {stat.number}
// // // //                   </div>
// // // //                   <div className="text-stone-300 font-medium">{stat.label}</div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* CTA Section */}
// // // //       <section className="py-20 bg-stone-50">
// // // //         <div className="max-w-4xl mx-auto text-center px-6">
// // // //           <div data-animate id="cta-section">
// // // //             <div className={`transition-all duration-1000 ${isVisible['cta-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //               <h2 
// // // //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // // //               >
// // // //                 Ready to Transform Your Space?
// // // //               </h2>
// // // //               <p className="text-xl text-stone-600 mb-8 max-w-2xl mx-auto">
// // // //                 Let's create something extraordinary together. Contact us today to begin your design journey.
// // // //               </p>
// // // //               <div data-animate id="cta-buttons">
// // // //                 <div className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-1000 delay-300 ${isVisible['cta-buttons'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // // //                   <button className="group bg-stone-900 text-stone-50 px-8 py-4 rounded-full hover:bg-stone-800 transition-all duration-300 transform hover:scale-105 font-semibold">
// // // //                     <span className="flex items-center gap-2">
// // // //                       Start Your Project
// // // //                       <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// // // //                     </span>
// // // //                   </button>
// // // //                   <button className="border-2 border-stone-900 text-stone-900 px-8 py-4 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-300 transform hover:scale-105 font-semibold">
// // // //                     Schedule Consultation
// // // //                   </button>
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default InteriorDesignWebsite;



// // // import React, { useState, useEffect, useRef } from 'react';
// // // import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';
// // // import PremiumFooter from './Footer';

// // // // Reusable RevealImage Component
// // // const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
// // //   const wrapperRef = useRef();
// // //   useEffect(() => {
// // //     const el = wrapperRef.current;
// // //     const observer = new IntersectionObserver(
// // //       entries => {
// // //         entries.forEach(entry => {
// // //           if (entry.isIntersecting) {
// // //             el.classList.add("revealed");
// // //             observer.unobserve(el);
// // //           }
// // //         });
// // //       },
// // //       { threshold: 0.3 }
// // //     );
// // //     if (el) observer.observe(el);
// // //     return () => {
// // //       if (el) observer.unobserve(el);
// // //     };
// // //   }, []);
  
// // //   return (
// // //     <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
// // //       <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
// // //       <div className="reveal-mask"></div>
// // //     </div>
// // //   );
// // // };

// // // const InteriorDesignWebsite = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [currentSlide, setCurrentSlide] = useState(0);
// // //   const [scrollY, setScrollY] = useState(0);
// // //   const [isVisible, setIsVisible] = useState({});

// // //   useEffect(() => {
// // //     const handleScroll = () => setScrollY(window.scrollY);
// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, []);

// // //   // Intersection Observer for scroll animations
// // //   useEffect(() => {
// // //     const observer = new IntersectionObserver(
// // //       (entries) => {
// // //         entries.forEach((entry) => {
// // //           if (entry.isIntersecting) {
// // //             setIsVisible(prev => ({
// // //               ...prev,
// // //               [entry.target.id]: true
// // //             }));
// // //           }
// // //         });
// // //       },
// // //       { 
// // //         threshold: 0.1,
// // //         rootMargin: '0px 0px -50px 0px'
// // //       }
// // //     );

// // //     const elements = document.querySelectorAll('[data-animate]');
// // //     elements.forEach((el) => observer.observe(el));

// // //     return () => observer.disconnect();
// // //   }, []);

// // //   const heroSlides = [
// // //     {
// // //       image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
// // //       title: "Luxury Living Redefined",
// // //       subtitle: "Crafting extraordinary spaces that inspire and elevate"
// // //     },
// // //     {
// // //       image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
// // //       title: "Modern Sophistication",
// // //       subtitle: "Where contemporary design meets timeless elegance"
// // //     },
// // //     {
// // //       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
// // //       title: "Architectural Excellence",
// // //       subtitle: "Transforming visions into breathtaking realities"
// // //     }
// // //   ];

// // //   const services = [
// // //     {
// // //       icon: <Home className="w-8 h-8" />,
// // //       title: "Residential Design",
// // //       description: "Complete home transformations with personalized luxury touches",
// // //       features: ["Custom Furniture", "Space Planning", "Color Consultation"]
// // //     },
// // //     {
// // //       icon: <Award className="w-8 h-8" />,
// // //       title: "Commercial Spaces",
// // //       description: "Innovative workplace and retail environments that inspire",
// // //       features: ["Office Design", "Retail Spaces", "Hospitality"]
// // //     },
// // //     {
// // //       icon: <Users className="w-8 h-8" />,
// // //       title: "Consultation",
// // //       description: "Expert guidance from concept to completion",
// // //       features: ["Design Strategy", "Project Management", "Styling Services"]
// // //     }
// // //   ];

// // //   const portfolio = [
// // //     {
// // //       id: 1,
// // //       title: "Manhattan Penthouse",
// // //       category: "Residential",
// // //       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop",
// // //       description: "A sophisticated urban retreat with panoramic city views"
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Modern Office Complex",
// // //       category: "Commercial",
// // //       image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
// // //       description: "Innovative workspace design promoting creativity and collaboration"
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Luxury Resort Suite",
// // //       category: "Hospitality",
// // //       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
// // //       description: "Elegant coastal design with natural materials and textures"
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Contemporary Villa",
// // //       category: "Residential",
// // //       image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
// // //       description: "Minimalist luxury with seamless indoor-outdoor living"
// // //     }
// // //   ];

// // //   useEffect(() => {
// // //     const interval = setInterval(() => {
// // //       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
// // //     }, 5000);
// // //     return () => clearInterval(interval);
// // //   }, []);

// // //   return (
// // //     <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
// // //       {/* Load Fonts */}
// // //       <link
// // //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// // //         rel="stylesheet"
// // //       />

// // //       {/* Global CSS for smooth scrolling and hidden scrollbars */}
// // //       <style jsx global>{`
// // //         html {
// // //           scroll-behavior: smooth;
// // //         }
        
// // //         /* Hide scrollbars completely */
// // //         ::-webkit-scrollbar {
// // //           width: 0px;
// // //           background: transparent;
// // //         }
        
// // //         body {
// // //           scrollbar-width: none;
// // //           -ms-overflow-style: none;
// // //           overflow-x: hidden;
// // //         }
        
// // //         /* Smooth scroll momentum */
// // //         * {
// // //           -webkit-overflow-scrolling: touch;
// // //         }
// // //       `}</style>

// // //       {/* Enhanced animations matching About page style */}
// // //       <style jsx>{`
// // //         /* RevealImage Effects */
// // //         .reveal-wrapper {
// // //           position: relative;
// // //           overflow: hidden;
// // //         }
        
// // //         .reveal-wrapper .reveal-mask {
// // //           position: absolute;
// // //           top: 0;
// // //           left: 0;
// // //           width: 100%;
// // //           height: 100%;
// // //           background: #f3f4f6;
// // //           transform: translateX(-100%);
// // //           transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //           z-index: 2;
// // //         }
        
// // //         .reveal-wrapper.revealed .reveal-mask {
// // //           transform: translateX(100%);
// // //         }
        
// // //         .reveal-wrapper img {
// // //           opacity: 0;
// // //           transform: scale(1.1);
// // //           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //         }
        
// // //         .reveal-wrapper.revealed img {
// // //           opacity: 1;
// // //           transform: scale(1);
// // //         }
        
// // //         /* Scroll Animations */
// // //         .fade-up {
// // //           opacity: 0;
// // //           transform: translateY(50px);
// // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //         }
        
// // //         .fade-up.visible {
// // //           opacity: 1;
// // //           transform: translateY(0);
// // //         }
        
// // //         .fade-left {
// // //           opacity: 0;
// // //           transform: translateX(-50px);
// // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //         }
        
// // //         .fade-left.visible {
// // //           opacity: 1;
// // //           transform: translateX(0);
// // //         }
        
// // //         .fade-right {
// // //           opacity: 0;
// // //           transform: translateX(50px);
// // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //         }
        
// // //         .fade-right.visible {
// // //           opacity: 1;
// // //           transform: translateX(0);
// // //         }
        
// // //         .zoom-in {
// // //           opacity: 0;
// // //           transform: scale(0.9);
// // //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// // //         }
        
// // //         .zoom-in.visible {
// // //           opacity: 1;
// // //           transform: scale(1);
// // //         }

// // //         @keyframes slideUp {
// // //           from {
// // //             opacity: 0;
// // //             transform: translateY(50px);
// // //           }
// // //           to {
// // //             opacity: 1;
// // //             transform: translateY(0);
// // //           }
// // //         }
// // //       `}</style>

// // //       {/* Hero Section */}
// // //       <section id="home" className="relative h-screen overflow-hidden">
// // //         {/* Background Slides */}
// // //         {heroSlides.map((slide, index) => (
// // //           <div
// // //             key={index}
// // //             className={`absolute inset-0 transition-all duration-1000 ${
// // //               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
// // //             }`}
// // //           >
// // //             <img
// // //               src={slide.image}
// // //               alt={slide.title}
// // //               className="w-full h-full object-cover"
// // //             />
// // //             <div className="absolute inset-0 bg-stone-900/40"></div>
// // //           </div>
// // //         ))}

// // //         {/* Content */}
// // //         <div className="relative z-10 h-full flex items-center justify-center">
// // //           <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
// // //             <div 
// // //               className="transform transition-all duration-1000 delay-300"
// // //               style={{
// // //                 transform: `translateY(${scrollY * 0.3}px)`,
// // //               }}
// // //             >
// // //               <h1 
// // //                 className="text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
// // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // //               >
// // //                 {heroSlides[currentSlide].title}
// // //               </h1>
// // //               <p className="text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
// // //                 {heroSlides[currentSlide].subtitle}
// // //               </p>
// // //               <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
// // //                 <button className="group bg-stone-50 text-stone-900 px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold">
// // //                   <span className="flex items-center gap-2">
// // //                     Explore Portfolio
// // //                     <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// // //                   </span>
// // //                 </button>
// // //                 <button className="group border-2 border-stone-50 text-stone-50 px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold">
// // //                   <span className="flex items-center gap-2">
// // //                     <Play className="w-5 h-5" />
// // //                     Watch Video
// // //                   </span>
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* Slide Indicators */}
// // //         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
// // //           {heroSlides.map((_, index) => (
// // //             <button
// // //               key={index}
// // //               onClick={() => setCurrentSlide(index)}
// // //               className={`w-3 h-3 rounded-full transition-all duration-300 ${
// // //                 index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
// // //               }`}
// // //             />
// // //           ))}
// // //         </div>

// // //         {/* Scroll Indicator */}
// // //         <div className="absolute bottom-8 right-8 animate-bounce">
// // //           <ChevronDown className="w-8 h-8 text-stone-50" />
// // //         </div>
// // //       </section>

// // //       {/* Our Process Section */}
// // //       <section className="py-20 bg-stone-50">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div className="grid lg:grid-cols-2 gap-16 items-start">
// // //             {/* Left Column - Title and Contact */}
// // //             <div data-animate id="process-left">
// // //               <div className={`transition-all duration-1000 ${isVisible['process-left'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //                 <h2 
// // //                   className="text-5xl md:text-6xl font-bold text-stone-900 mb-8 leading-tight"
// // //                   style={{fontFamily: "'Playfair Display', serif"}}
// // //                 >
// // //                   OUR PROCESS
// // //                 </h2>
// // //                 <div className="inline-block">
// // //                   <button className="text-stone-900 font-semibold text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-colors duration-300">
// // //                     CONTACT US
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Right Column - Process Steps */}
// // //             <div className="space-y-16">
// // //               {[
// // //                 {
// // //                   number: "01.",
// // //                   title: "DESIGN YOUR VISION BOARD.",
// // //                   description: "Eget pharetra platea taciti amet egestas phasellus lobortis posuere posuere hendrerit nullam interdum el congue amet risus habitasse magna cursus libero nam cursus platea."
// // //                 },
// // //                 {
// // //                   number: "02.",
// // //                   title: "STRATEGIZE YOUR SPACE.",
// // //                   description: "Integer aliquam facilisis porttitor lobortis pharetra arcu. Tellus litorate varius phasellus non ultrices odio blandit morbi. Ex euismod magnis hendrerit sed aliquet velit."
// // //                 },
// // //                 {
// // //                   number: "03.",
// // //                   title: "ELEVATE YOUR DECOR.",
// // //                   description: "Aenean malesuada torquent pulvinar mattis elits ipsum scelerisque varius mi in ests Integer aptent lact ultrices penatibus accumsan arcu cursus praesent vitae."
// // //                 }
// // //               ].map((step, index) => (
// // //                 <div 
// // //                   key={index}
// // //                   data-animate 
// // //                   id={`process-step-${index}`}
// // //                   className={`transition-all duration-1000 delay-${index * 200} ${isVisible[`process-step-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// // //                 >
// // //                   <div className="border-b border-stone-300 pb-8">
// // //                     <h3 
// // //                       className="text-2xl md:text-3xl font-bold text-stone-900 mb-4"
// // //                       style={{fontFamily: "'Playfair Display', serif"}}
// // //                     >
// // //                       <span className="text-stone-500 mr-4">{step.number}</span>
// // //                       {step.title}
// // //                     </h3>
// // //                     <p className="text-stone-600 leading-relaxed text-lg">
// // //                       {step.description}
// // //                     </p>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Our Testimonials Section */}
// // //       <section className="py-20 bg-stone-100">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div data-animate id="testimonials-header">
// // //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['testimonials-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //               <h2 
// // //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // //               >
// // //                 OUR TESTIMONIALS
// // //               </h2>
// // //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // //                 Pharetra dapibus phasellus vehicula mauris aliquam tristique placerat magna adipiscing magna netus.
// // //               </p>
// // //             </div>
// // //           </div>

// // //           <div className="grid lg:grid-cols-3 gap-8 items-start">
// // //             {/* Left Column - Image */}
// // //             <div data-animate id="testimonials-image">
// // //               <div className={`transition-all duration-1000 ${isVisible['testimonials-image'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
// // //                 <RevealImage
// // //                   src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=800&fit=crop"
// // //                   alt="Interior Design"
// // //                   className="h-[600px] rounded-2xl"
// // //                 />
// // //               </div>
// // //             </div>

// // //             {/* Right Columns - Testimonials */}
// // //             <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
// // //               {[
// // //                 {
// // //                   quote: "RoomFlow completely transformed our space with creative designs and flawless attention to detail!",
// // //                   name: "SOPHIE MOORE",
// // //                   location: "NEW YORK"
// // //                 },
// // //                 {
// // //                   quote: "We couldn't have asked for a better design experience—RoomFlow exceeded all our expectations!",
// // //                   name: "MILLER EVANS",
// // //                   location: "LOS ANGELES"
// // //                 },
// // //                 {
// // //                   quote: "Every room designed by RoomFlow feels personalized, beautiful, and incredibly functional.",
// // //                   name: "JOHN CARTER",
// // //                   location: "LOS ANGELES"
// // //                 },
// // //                 {
// // //                   quote: "From start to finish, RoomFlow delivered exceptional service and breathtaking designs. Truly the best!",
// // //                   name: "LILLY GREEN",
// // //                   location: "NEW YORK"
// // //                 }
// // //               ].map((testimonial, index) => (
// // //                 <div 
// // //                   key={index}
// // //                   data-animate 
// // //                   id={`testimonial-${index}`}
// // //                   className={`bg-stone-200 p-8 rounded-2xl transition-all duration-1000 delay-${index * 150} ${isVisible[`testimonial-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// // //                 >
// // //                   <p className="text-stone-700 mb-6 text-lg leading-relaxed">
// // //                     "{testimonial.quote}"
// // //                   </p>
// // //                   <div>
// // //                     <div className="font-bold text-stone-900 text-sm tracking-wide">
// // //                       {testimonial.name}
// // //                     </div>
// // //                     <div className="text-stone-500 text-sm">
// // //                       {testimonial.location}
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Portfolio Section */}
// // //       <section id="portfolio" className="py-20 bg-stone-50">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div data-animate id="portfolio-header">
// // //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //               <h2 
// // //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // //               >
// // //                 Featured Projects
// // //               </h2>
// // //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // //                 Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
// // //               </p>
// // //             </div>
// // //           </div>

// // //           <div data-animate id="portfolio-grid">
// // //             <div className={`grid md:grid-cols-2 gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //               {portfolio.map((project, index) => (
// // //                 <div
// // //                   key={project.id}
// // //                   className={`group relative overflow-hidden rounded-3xl bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
// // //                   style={{ transitionDelay: `${index * 200}ms` }}
// // //                 >
// // //                   <RevealImage
// // //                     src={project.image}
// // //                     alt={project.title}
// // //                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// // //                   />
// // //                   <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// // //                   <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
// // //                     <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
// // //                       {project.category}
// // //                     </span>
// // //                     <h3 className="text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
// // //                       {project.title}
// // //                     </h3>
// // //                     <p className="text-stone-200 mb-4">{project.description}</p>
// // //                     <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
// // //                       View Project <ArrowRight className="w-5 h-5" />
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Enhanced Services Section */}
// // //       <section className="py-20 bg-stone-100">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div className="flex justify-between items-end mb-16">
// // //             <div data-animate id="services-title">
// // //               <h2 
// // //                 className={`text-5xl md:text-6xl font-bold text-stone-900 transition-all duration-1000 ${isVisible['services-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// // //                 style={{fontFamily: "'Playfair Display', serif"}}
// // //               >
// // //                 OUR SERVICES
// // //               </h2>
// // //             </div>
// // //             <div data-animate id="services-link">
// // //               <button className={`text-stone-900 font-semibold text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-all duration-300 ${isVisible['services-link'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //                 BROWSE ALL SERVICES
// // //               </button>
// // //             </div>
// // //           </div>

// // //           <div className="grid md:grid-cols-2 gap-8">
// // //             {[
// // //               {
// // //                 title: "SPACE PLANNING",
// // //                 description: "Dolor lacinia egestas eros porta natoque magnis phasellus sagittis ultrices felis.",
// // //                 image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop"
// // //               },
// // //               {
// // //                 title: "FURNITURE SELECTION",
// // //                 description: "Class hendrerit nulla platea est fillius ut velit eros donec odio ornare dui leo.",
// // //                 image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop"
// // //               }
// // //             ].map((service, index) => (
// // //               <div 
// // //                 key={index}
// // //                 data-animate 
// // //                 id={`service-card-${index}`}
// // //                 className={`relative overflow-hidden rounded-3xl aspect-[4/3] group transition-all duration-1000 delay-${index * 200} ${isVisible[`service-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// // //               >
// // //                 <RevealImage
// // //                   src={service.image}
// // //                   alt={service.title}
// // //                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// // //                 />
// // //                 <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent"></div>
// // //                 <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50">
// // //                   <h3 
// // //                     className="text-3xl font-bold mb-4"
// // //                     style={{fontFamily: "'Playfair Display', serif"}}
// // //                   >
// // //                     {service.title}
// // //                   </h3>
// // //                   <p className="text-stone-200 text-lg leading-relaxed">
// // //                     {service.description}
// // //                   </p>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Stats Section */}
// // //       <section className="py-20 bg-stone-900 text-stone-50">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div data-animate id="stats-section">
// // //             <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 transition-all duration-1000 ${isVisible['stats-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //               {[
// // //                 { number: "150+", label: "Projects Completed" },
// // //                 { number: "50+", label: "Happy Clients" },
// // //                 { number: "15+", label: "Years Experience" },
// // //                 { number: "25+", label: "Design Awards" }
// // //               ].map((stat, index) => (
// // //                 <div 
// // //                   key={index} 
// // //                   className={`text-center fade-up ${isVisible['stats-section'] ? 'visible' : ''}`}
// // //                   style={{ transitionDelay: `${index * 200}ms` }}
// // //                 >
// // //                   <div 
// // //                     className="text-4xl md:text-5xl font-bold mb-2"
// // //                     style={{fontFamily: "'Playfair Display', serif"}}
// // //                   >
// // //                     {stat.number}
// // //                   </div>
// // //                   <div className="text-stone-300 font-medium">{stat.label}</div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* CTA Section - Updated to match the bedroom image style */}
// // //       <section className="relative py-0 bg-stone-50 overflow-hidden">
// // //         <div className="relative h-[600px] md:h-[700px]">
// // //           {/* Background Image */}
// // //           <img
// // //             src="https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1920&h=1080&fit=crop"
// // //             alt="Bedroom Interior"
// // //             className="w-full h-full object-cover"
// // //           />
// // //           <div className="absolute inset-0 bg-stone-900/40"></div>
          
// // //           {/* Content */}
// // //           <div className="relative z-10 h-full flex items-center">
// // //             <div className="max-w-7xl mx-auto px-6 w-full">
// // //               <div className="max-w-3xl">
// // //                 <div data-animate id="cta-content">
// // //                   <div className={`transition-all duration-1000 ${isVisible['cta-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// // //                     <h2 
// // //                       className="text-5xl md:text-7xl font-bold text-stone-50 mb-8 leading-tight"
// // //                       style={{fontFamily: "'Playfair Display', serif"}}
// // //                     >
// // //                       ARE YOU READY TO<br />
// // //                       CREATE YOUR NEW SPACE?
// // //                     </h2>
                    
// // //                     {/* Contact Button positioned in bottom right */}
// // //                     <div className="absolute bottom-12 right-12">
// // //                       <button className="text-stone-50 font-semibold text-xl border-b-2 border-stone-50 pb-2 hover:border-stone-300 transition-all duration-300 transform hover:scale-105">
// // //                         CONTACT US
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       <PremiumFooter/>

// // //     </div>
// // //   );
// // // };

// // // export default InteriorDesignWebsite;



// // import React, { useState, useEffect, useRef } from 'react';
// // import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';

// // // Reusable RevealImage Component
// // const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
// //   const wrapperRef = useRef();
// //   useEffect(() => {
// //     const el = wrapperRef.current;
// //     const observer = new IntersectionObserver(
// //       entries => {
// //         entries.forEach(entry => {
// //           if (entry.isIntersecting) {
// //             el.classList.add("revealed");
// //             observer.unobserve(el);
// //           }
// //         });
// //       },
// //       { threshold: 0.3 }
// //     );
// //     if (el) observer.observe(el);
// //     return () => {
// //       if (el) observer.unobserve(el);
// //     };
// //   }, []);
  
// //   return (
// //     <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
// //       <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
// //       <div className="reveal-mask"></div>
// //     </div>
// //   );
// // };

// // const InteriorDesignWebsite = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [currentSlide, setCurrentSlide] = useState(0);
// //   const [scrollY, setScrollY] = useState(0);
// //   const [isVisible, setIsVisible] = useState({});

// //   useEffect(() => {
// //     const handleScroll = () => setScrollY(window.scrollY);
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   // Intersection Observer for scroll animations
// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         entries.forEach((entry) => {
// //           if (entry.isIntersecting) {
// //             setIsVisible(prev => ({
// //               ...prev,
// //               [entry.target.id]: true
// //             }));
// //           }
// //         });
// //       },
// //       { 
// //         threshold: 0.1,
// //         rootMargin: '0px 0px -50px 0px'
// //       }
// //     );

// //     const elements = document.querySelectorAll('[data-animate]');
// //     elements.forEach((el) => observer.observe(el));

// //     return () => observer.disconnect();
// //   }, []);

// //   const heroSlides = [
// //     {
// //       image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
// //       title: "Luxury Living Redefined",
// //       subtitle: "Crafting extraordinary spaces that inspire and elevate"
// //     },
// //     {
// //       image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
// //       title: "Modern Sophistication",
// //       subtitle: "Where contemporary design meets timeless elegance"
// //     },
// //     {
// //       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
// //       title: "Architectural Excellence",
// //       subtitle: "Transforming visions into breathtaking realities"
// //     }
// //   ];

// //   const portfolio = [
// //     {
// //       id: 1,
// //       title: "Manhattan Penthouse",
// //       category: "Residential",
// //       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop",
// //       description: "A sophisticated urban retreat with panoramic city views"
// //     },
// //     {
// //       id: 2,
// //       title: "Modern Office Complex",
// //       category: "Commercial",
// //       image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
// //       description: "Innovative workspace design promoting creativity and collaboration"
// //     },
// //     {
// //       id: 3,
// //       title: "Luxury Resort Suite",
// //       category: "Hospitality",
// //       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
// //       description: "Elegant coastal design with natural materials and textures"
// //     },
// //     {
// //       id: 4,
// //       title: "Contemporary Villa",
// //       category: "Residential",
// //       image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
// //       description: "Minimalist luxury with seamless indoor-outdoor living"
// //     }
// //   ];

// //   useEffect(() => {
// //     const interval = setInterval(() => {
// //       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
// //     }, 5000);
// //     return () => clearInterval(interval);
// //   }, []);

// //   return (
// //     <div className="min-h-screen text-stone-800 overflow-x-hidden" style={{backgroundColor: '#f4f1ec'}}>
// //       {/* Load Fonts */}
// //       <link
// //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// //         rel="stylesheet"
// //       />

// //       {/* Global CSS for smooth scrolling and hidden scrollbars */}
// //       <style jsx global>{`
// //         html {
// //           scroll-behavior: smooth;
// //           scroll-padding-top: 80px;
// //         }
        
// //         /* Hide scrollbars completely */
// //         ::-webkit-scrollbar {
// //           width: 0px;
// //           background: transparent;
// //         }
        
// //         body {
// //           scrollbar-width: none;
// //           -ms-overflow-style: none;
// //           overflow-x: hidden;
// //         }
        
// //         /* Enhanced smooth scroll momentum */
// //         * {
// //           -webkit-overflow-scrolling: touch;
// //         }
        
// //         /* Smooth transitions for all elements */
// //         *, *::before, *::after {
// //           transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
// //         }
        
// //         /* Optimize rendering performance */
// //         .will-change-transform {
// //           will-change: transform;
// //         }
        
// //         .will-change-opacity {
// //           will-change: opacity;
// //         }
// //       `}</style>

// //       {/* Enhanced animations */}
// //       <style jsx>{`
// //         /* RevealImage Effects */
// //         .reveal-wrapper {
// //           position: relative;
// //           overflow: hidden;
// //         }
        
// //         .reveal-wrapper .reveal-mask {
// //           position: absolute;
// //           top: 0;
// //           left: 0;
// //           width: 100%;
// //           height: 100%;
// //           background: #f3f4f6;
// //           transform: translateX(-100%);
// //           transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// //           z-index: 2;
// //         }
        
// //         .reveal-wrapper.revealed .reveal-mask {
// //           transform: translateX(100%);
// //         }
        
// //         .reveal-wrapper img {
// //           opacity: 0;
// //           transform: scale(1.1);
// //           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// //         }
        
// //         .reveal-wrapper.revealed img {
// //           opacity: 1;
// //           transform: scale(1);
// //         }
        
// //         /* Scroll Animations */
// //         .fade-up {
// //           opacity: 0;
// //           transform: translateY(50px);
// //           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// //         }
        
// //         .fade-up.visible {
// //           opacity: 1;
// //           transform: translateY(0);
// //         }

// //         @keyframes slideUp {
// //           from {
// //             opacity: 0;
// //             transform: translateY(50px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //       `}</style>

// //       {/* Hero Section */}
// //       <section id="home" className="relative h-screen overflow-hidden">
// //         {/* Background Slides */}
// //         {heroSlides.map((slide, index) => (
// //           <div
// //             key={index}
// //             className={`absolute inset-0 transition-all duration-1000 ${
// //               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
// //             }`}
// //           >
// //             <img
// //               src={slide.image}
// //               alt={slide.title}
// //               className="w-full h-full object-cover"
// //             />
// //             <div className="absolute inset-0 bg-stone-900/40"></div>
// //           </div>
// //         ))}

// //         {/* Content */}
// //         <div className="relative z-10 h-full flex items-center justify-center">
// //           <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
// //             <div 
// //               className="transform transition-all duration-1000 delay-300"
// //               style={{
// //                 transform: `translateY(${scrollY * 0.3}px)`,
// //               }}
// //             >
// //               <h1 
// //                 className="text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 {heroSlides[currentSlide].title}
// //               </h1>
// //               <p className="text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
// //                 {heroSlides[currentSlide].subtitle}
// //               </p>
// //               <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
// //                 <button className="group bg-stone-50 text-stone-900 px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold">
// //                   <span className="flex items-center gap-2">
// //                     Explore Portfolio
// //                     <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
// //                   </span>
// //                 </button>
// //                 <button className="group border-2 border-stone-50 text-stone-50 px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold">
// //                   <span className="flex items-center gap-2">
// //                     <Play className="w-5 h-5" />
// //                     Watch Video
// //                   </span>
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Slide Indicators */}
// //         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
// //           {heroSlides.map((_, index) => (
// //             <button
// //               key={index}
// //               onClick={() => setCurrentSlide(index)}
// //               className={`w-3 h-3 rounded-full transition-all duration-300 ${
// //                 index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
// //               }`}
// //             />
// //           ))}
// //         </div>

// //         {/* Scroll Indicator */}
// //         <div className="absolute bottom-8 right-8 animate-bounce">
// //           <ChevronDown className="w-8 h-8 text-stone-50" />
// //         </div>
// //       </section>

// //       {/* Our Process Section */}
// //       <section className="py-20 bg-white">
// //         <div className="max-w-7xl mx-auto px-6">
// //           <div className="grid lg:grid-cols-2 gap-16 items-start">
// //             {/* Left Column - Title and Contact */}
// //             <div data-animate id="process-left">
// //               <div className={`transition-all duration-1000 ${isVisible['process-left'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //                 <h2 
// //                   className="text-5xl md:text-6xl font-bold text-stone-900 mb-8 leading-tight"
// //                   style={{fontFamily: "'Playfair Display', serif"}}
// //                 >
// //                   OUR PROCESS
// //                 </h2>
// //                 <div className="inline-block">
// //                   <button className="text-stone-900 font-semibold text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-colors duration-300">
// //                     CONTACT US
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Right Column - Process Steps */}
// //             <div className="space-y-16">
// //               {[
// //                 {
// //                   number: "01.",
// //                   title: "DESIGN YOUR VISION BOARD.",
// //                   description: "Eget pharetra platea taciti amet egestas phasellus lobortis posuere posuere hendrerit nullam interdum el congue amet risus habitasse magna cursus libero nam cursus platea."
// //                 },
// //                 {
// //                   number: "02.",
// //                   title: "STRATEGIZE YOUR SPACE.",
// //                   description: "Integer aliquam facilisis porttitor lobortis pharetra arcu. Tellus litorate varius phasellus non ultrices odio blandit morbi. Ex euismod magnis hendrerit sed aliquet velit."
// //                 },
// //                 {
// //                   number: "03.",
// //                   title: "ELEVATE YOUR DECOR.",
// //                   description: "Aenean malesuada torquent pulvinar mattis elits ipsum scelerisque varius mi in ests Integer aptent lact ultrices penatibus accumsan arcu cursus praesent vitae."
// //                 }
// //               ].map((step, index) => (
// //                 <div 
// //                   key={index}
// //                   data-animate 
// //                   id={`process-step-${index}`}
// //                   className={`transition-all duration-1000 delay-${index * 200} ${isVisible[`process-step-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //                 >
// //                   <div className="border-b border-stone-300 pb-8">
// //                     <h3 
// //                       className="text-2xl md:text-3xl font-bold text-stone-900 mb-4"
// //                       style={{fontFamily: "'Playfair Display', serif"}}
// //                     >
// //                       <span className="text-stone-500 mr-4">{step.number}</span>
// //                       {step.title}
// //                     </h3>
// //                     <p className="text-stone-600 leading-relaxed text-lg">
// //                       {step.description}
// //                     </p>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Our Testimonials Section */}
// //       <section className="py-20" style={{backgroundColor: '#f4f1ec'}}>
// //         <div className="max-w-7xl mx-auto px-6">
// //           <div data-animate id="testimonials-header">
// //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['testimonials-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               <h2 
// //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 OUR TESTIMONIALS
// //               </h2>
// //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// //                 Pharetra dapibus phasellus vehicula mauris aliquam tristique placerat magna adipiscing magna netus.
// //               </p>
// //             </div>
// //           </div>

// //           <div className="grid lg:grid-cols-3 gap-8 items-start">
// //             {/* Left Column - Image */}
// //             <div data-animate id="testimonials-image">
// //               <div className={`transition-all duration-1000 ${isVisible['testimonials-image'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
// //                 <RevealImage
// //                   src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=800&fit=crop"
// //                   alt="Interior Design"
// //                   className="h-[600px]"
// //                 />
// //               </div>
// //             </div>

// //             {/* Right Columns - Testimonials */}
// //             <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
// //               {[
// //                 {
// //                   quote: "RoomFlow completely transformed our space with creative designs and flawless attention to detail!",
// //                   name: "SOPHIE MOORE",
// //                   location: "NEW YORK"
// //                 },
// //                 {
// //                   quote: "We couldn't have asked for a better design experience—RoomFlow exceeded all our expectations!",
// //                   name: "MILLER EVANS",
// //                   location: "LOS ANGELES"
// //                 },
// //                 {
// //                   quote: "Every room designed by RoomFlow feels personalized, beautiful, and incredibly functional.",
// //                   name: "JOHN CARTER",
// //                   location: "LOS ANGELES"
// //                 },
// //                 {
// //                   quote: "From start to finish, RoomFlow delivered exceptional service and breathtaking designs. Truly the best!",
// //                   name: "LILLY GREEN",
// //                   location: "NEW YORK"
// //                 }
// //               ].map((testimonial, index) => (
// //                 <div 
// //                   key={index}
// //                   data-animate 
// //                   id={`testimonial-${index}`}
// //                   className={`bg-white p-8 transition-all duration-1000 delay-${index * 150} ${isVisible[`testimonial-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //                 >
// //                   <p className="text-stone-700 mb-6 text-lg leading-relaxed">
// //                     "{testimonial.quote}"
// //                   </p>
// //                   <div>
// //                     <div className="font-bold text-stone-900 text-sm tracking-wide">
// //                       {testimonial.name}
// //                     </div>
// //                     <div className="text-stone-500 text-sm">
// //                       {testimonial.location}
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Portfolio Section */}
// //       <section id="portfolio" className="py-20 bg-white">
// //         <div className="max-w-7xl mx-auto px-6">
// //           <div data-animate id="portfolio-header">
// //             <div className={`text-center mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               <h2 
// //                 className="text-5xl md:text-6xl font-bold text-stone-900 mb-6"
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 Featured Projects
// //               </h2>
// //               <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// //                 Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
// //               </p>
// //             </div>
// //           </div>

// //           <div data-animate id="portfolio-grid">
// //             <div className={`grid md:grid-cols-2 gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               {portfolio.map((project, index) => (
// //                 <div
// //                   key={project.id}
// //                   className={`group relative overflow-hidden bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
// //                   style={{ transitionDelay: `${index * 200}ms` }}
// //                 >
// //                   <RevealImage
// //                     src={project.image}
// //                     alt={project.title}
// //                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// //                   />
// //                   <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// //                   <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
// //                     <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
// //                       {project.category}
// //                     </span>
// //                     <h3 className="text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
// //                       {project.title}
// //                     </h3>
// //                     <p className="text-stone-200 mb-4">{project.description}</p>
// //                     <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
// //                       View Project <ArrowRight className="w-5 h-5" />
// //                     </button>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Enhanced Services Section */}
// //       <section className="py-20" style={{backgroundColor: '#f4f1ec'}}>
// //         <div className="max-w-7xl mx-auto px-6">
// //           <div className="flex justify-between items-end mb-16">
// //             <div data-animate id="services-title">
// //               <h2 
// //                 className={`text-5xl md:text-6xl font-bold text-stone-900 transition-all duration-1000 ${isVisible['services-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 OUR SERVICES
// //               </h2>
// //             </div>
// //             <div data-animate id="services-link">
// //               <button className={`text-stone-900 font-semibold text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-all duration-300 ${isVisible['services-link'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //                 BROWSE ALL SERVICES
// //               </button>
// //             </div>
// //           </div>

// //           <div className="grid md:grid-cols-2 gap-8">
// //             {[
// //               {
// //                 title: "SPACE PLANNING",
// //                 description: "Dolor lacinia egestas eros porta natoque magnis phasellus sagittis ultrices felis.",
// //                 image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop"
// //               },
// //               {
// //                 title: "FURNITURE SELECTION",
// //                 description: "Class hendrerit nulla platea est fillius ut velit eros donec odio ornare dui leo.",
// //                 image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop"
// //               }
// //             ].map((service, index) => (
// //               <div 
// //                 key={index}
// //                 data-animate 
// //                 id={`service-card-${index}`}
// //                 className={`relative overflow-hidden aspect-[4/3] group transition-all duration-1000 delay-${index * 200} ${isVisible[`service-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //               >
// //                 <RevealImage
// //                   src={service.image}
// //                   alt={service.title}
// //                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
// //                 />
// //                 <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent"></div>
// //                 <div className="absolute bottom-0 left-0 right-0 p-8 text-stone-50">
// //                   <h3 
// //                     className="text-3xl font-bold mb-4"
// //                     style={{fontFamily: "'Playfair Display', serif"}}
// //                   >
// //                     {service.title}
// //                   </h3>
// //                   <p className="text-stone-200 text-lg leading-relaxed">
// //                     {service.description}
// //                   </p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Stats Section */}
// //       {/* <section className="py-20 bg-stone-900 text-stone-50">
// //         <div className="max-w-7xl mx-auto px-6">
// //           <div data-animate id="stats-section">
// //             <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 transition-all duration-1000 ${isVisible['stats-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               {[
// //                 { number: "150+", label: "Projects Completed" },
// //                 { number: "50+", label: "Happy Clients" },
// //                 { number: "15+", label: "Years Experience" },
// //                 { number: "25+", label: "Design Awards" }
// //               ].map((stat, index) => (
// //                 <div 
// //                   key={index} 
// //                   className={`text-center fade-up ${isVisible['stats-section'] ? 'visible' : ''}`}
// //                   style={{ transitionDelay: `${index * 200}ms` }}
// //                 >
// //                   <div 
// //                     className="text-4xl md:text-5xl font-bold mb-2"
// //                     style={{fontFamily: "'Playfair Display', serif"}}
// //                   >
// //                     {stat.number}
// //                   </div>
// //                   <div className="text-stone-300 font-medium">{stat.label}</div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* CTA Section - Simple and clean like reference */}
// //    <section className="relative py-0 overflow-hidden" style={{backgroundColor: '#f4f1ec'}}>
// //         <div className="relative h-[600px] md:h-[700px]">
// //           {/* Background Image */}
// //           <img
// //             src="https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1920&h=1080&fit=crop"
// //             alt="Bedroom Interior"
// //             className="w-full h-full object-cover"
// //           />
// //           {/* Full dark overlay */}
// //           <div className="absolute inset-0" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}></div>
          
// //           {/* Content */}
// //           <div className="relative z-20 h-full flex items-center">
// //             <div className="max-w-7xl mx-auto px-6 w-full relative h-full">
// //               {/* Main heading */}
// //               <div className="max-w-4xl flex items-center h-full">
// //                 <h2 
// //                   className="text-5xl md:text-7xl font-bold leading-tight"
// //                   style={{
// //                     fontFamily: "'Playfair Display', serif",
// //                     color: '#ffffff',
// //                     textShadow: '2px 2px 4px rgba(0,0,0,1)'
// //                   }}
// //                 >
// //                   ARE YOU READY TO<br />
// //                   CREATE YOUR NEW SPACE?
// //                 </h2>
// //               </div>
              
// //               {/* Contact button in bottom right */}
// //               <div className="absolute bottom-12 right-12">
// //                 <div style={{color: '#ffffff', textShadow: '1px 1px 2px rgba(0,0,0,1)'}} className="font-semibold text-xl">
// //                   <div>CONTACT US</div>
// //                   <div style={{backgroundColor: '#ffffff', height: '2px', marginTop: '8px'}}></div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default InteriorDesignWebsite;

// import React, { useState, useEffect, useRef } from 'react';
// import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';

// // Footer Component
// const PremiumFooter = () => {
//   return (
//     <footer className="bg-stone-900 text-stone-300">
//       <div className="max-w-7xl mx-auto px-6 py-16">
//         <div className="grid md:grid-cols-4 gap-8">
//           <div>
//             <h3 className="text-2xl font-bold text-stone-50 mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
//               RoomFlow
//             </h3>
//             <p className="text-stone-400 leading-relaxed">
//               Creating extraordinary spaces that inspire and elevate your lifestyle.
//             </p>
//           </div>
//           <div>
//             <h4 className="font-semibold text-stone-50 mb-4">Services</h4>
//             <ul className="space-y-2">
//               <li><a href="#" className="hover:text-stone-50 transition-colors">Interior Design</a></li>
//               <li><a href="#" className="hover:text-stone-50 transition-colors">Space Planning</a></li>
//               <li><a href="#" className="hover:text-stone-50 transition-colors">Furniture Selection</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-semibold text-stone-50 mb-4">Company</h4>
//             <ul className="space-y-2">
//               <li><a href="#" className="hover:text-stone-50 transition-colors">About</a></li>
//               <li><a href="#" className="hover:text-stone-50 transition-colors">Portfolio</a></li>
//               <li><a href="#" className="hover:text-stone-50 transition-colors">Contact</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-semibold text-stone-50 mb-4">Contact</h4>
//             <p className="text-stone-400">123 Design Street<br />New York, NY 10001<br />contact@roomflow.com</p>
//           </div>
//         </div>
//         <div className="border-t border-stone-700 mt-12 pt-8 text-center">
//           <p>&copy; 2025 RoomFlow. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// // Reusable RevealImage Component - Fixed for proper scroll triggering
// const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
//   const wrapperRef = useRef();
//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             el.classList.add("revealed");
//             observer.unobserve(el);
//           }
//         });
//       },
//       { 
//         threshold: 0.1,
//         rootMargin: '0px 0px -100px 0px'
//       }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
//       <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
//       <div className="reveal-mask"></div>
//     </div>
//   );
// };

// const InteriorDesignWebsite = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [scrollY, setScrollY] = useState(0);
//   const [isVisible, setIsVisible] = useState({});
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect mobile devices
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Optimized scroll handler with throttling
//   useEffect(() => {
//     let ticking = false;
    
//     const handleScroll = () => {
//       if (!ticking) {
//         requestAnimationFrame(() => {
//           setScrollY(window.scrollY);
//           ticking = false;
//         });
//         ticking = true;
//       }
//     };

//     // Use passive listeners for better performance
//     window.addEventListener('scroll', handleScroll, { passive: true });
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Intersection Observer for scroll animations
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(prev => ({
//               ...prev,
//               [entry.target.id]: true
//             }));
//           }
//         });
//       },
//       { 
//         threshold: 0.1,
//         rootMargin: '0px 0px -20px 0px'
//       }
//     );

//     const elements = document.querySelectorAll('[data-animate]');
//     elements.forEach((el) => observer.observe(el));

//     return () => observer.disconnect();
//   }, []);

//   const heroSlides = [
//     {
//       image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
//       title: "Luxury Living Redefined",
//       subtitle: "Crafting extraordinary spaces that inspire and elevate"
//     },
//     {
//       image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
//       title: "Modern Sophistication",
//       subtitle: "Where contemporary design meets timeless elegance"
//     },
//     {
//       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
//       title: "Architectural Excellence",
//       subtitle: "Transforming visions into breathtaking realities"
//     }
//   ];

//   const portfolio = [
//     {
//       id: 1,
//       title: "Manhattan Penthouse",
//       category: "Residential",
//       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop",
//       description: "A sophisticated urban retreat with panoramic city views"
//     },
//     {
//       id: 2,
//       title: "Modern Office Complex",
//       category: "Commercial",
//       image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
//       description: "Innovative workspace design promoting creativity and collaboration"
//     },
//     {
//       id: 3,
//       title: "Luxury Resort Suite",
//       category: "Hospitality",
//       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
//       description: "Elegant coastal design with natural materials and textures"
//     },
//     {
//       id: 4,
//       title: "Contemporary Villa",
//       category: "Residential",
//       image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
//       description: "Minimalist luxury with seamless indoor-outdoor living"
//     }
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="min-h-screen text-stone-800" style={{backgroundColor: '#f4f1ec'}}>
//       {/* Load Fonts */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
//         rel="stylesheet"
//       />

//       {/* Optimized Global Styles for Smooth Scrolling */}
//       <style jsx global>{`
//         * {
//           box-sizing: border-box;
//         }
        
//         html {
//           scroll-behavior: smooth;
//           scroll-padding-top: 80px;
//           overflow-x: hidden;
//         }
        
//         body {
//           margin: 0;
//           padding: 0;
//           overflow-x: hidden;
//           -webkit-font-smoothing: antialiased;
//           -moz-osx-font-smoothing: grayscale;
//           text-rendering: optimizeLegibility;
//         }
        
//         /* Enhanced mobile scrolling */
//         body, html {
//           -webkit-overflow-scrolling: touch;
//           overscroll-behavior: none;
//         }
        
//         /* Hide scrollbars while maintaining functionality */
//         ::-webkit-scrollbar {
//           width: 0px;
//           height: 0px;
//           background: transparent;
//         }
        
//         body {
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }
        
//         /* Optimize rendering performance */
//         * {
//           -webkit-transform: translateZ(0);
//           -moz-transform: translateZ(0);
//           -ms-transform: translateZ(0);
//           -o-transform: translateZ(0);
//           transform: translateZ(0);
//         }
        
//         /* Smooth transitions */
//         *, *::before, *::after {
//           transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         /* Performance optimizations for mobile */
//         @media (max-width: 768px) {
//           * {
//             -webkit-transform: none !important;
//             transform: none !important;
//           }
          
//           .parallax-disabled {
//             transform: none !important;
//           }
//         }
        
//         /* Reduce motion for users who prefer it */
//         @media (prefers-reduced-motion: reduce) {
//           * {
//             animation-duration: 0.01ms !important;
//             animation-iteration-count: 1 !important;
//             transition-duration: 0.01ms !important;
//             scroll-behavior: auto !important;
//           }
//         }
//       `}</style>

//       {/* Component-specific styles */}
//       <style jsx>{`
//         /* RevealImage Effects - Exact copy from reference */
//         .reveal-wrapper {
//           position: relative;
//           overflow: hidden;
//         }
        
//         .reveal-wrapper .reveal-mask {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: #f4f1ec;
//           transform: translateX(-100%);
//           transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           z-index: 2;
//         }
        
//         .reveal-wrapper.revealed .reveal-mask {
//           transform: translateX(100%);
//         }
        
//         .reveal-wrapper img {
//           opacity: 0;
//           transform: scale(1.1);
//           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .reveal-wrapper.revealed img {
//           opacity: 1;
//           transform: scale(1);
//         }

//         /* Optimized animations */
//         .fade-up {
//           opacity: 0;
//           transform: translateY(30px);
//           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .fade-up.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         /* Mobile-specific optimizations */
//         @media (max-width: 768px) {
//           .mobile-optimized {
//             transform: none !important;
//           }
          
//           .hero-parallax {
//             transform: none !important;
//           }
//         }
//       `}</style>

//       {/* Hero Section */}
//       <section id="home" className="relative h-screen overflow-hidden">
//         {/* Background Slides */}
//         {heroSlides.map((slide, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-all duration-1000 ${
//               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
//             }`}
//           >
//             <img
//               src={slide.image}
//               alt={slide.title}
//               className="w-full h-full object-cover"
//               loading={index === 0 ? "eager" : "lazy"}
//             />
//             <div className="absolute inset-0 bg-stone-900/40"></div>
//           </div>
//         ))}

//         {/* Content */}
//         <div className="relative z-10 h-full flex items-center justify-center">
//           <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
//             <div 
//               className={`transform transition-all duration-1000 delay-300 ${
//                 isMobile ? 'mobile-optimized' : ''
//               }`}
//               style={{
//                 transform: isMobile ? 'none' : `translateY(${scrollY * 0.2}px)`,
//               }}
//             >
//               <h1 
//                 className="text-4xl sm:text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 {heroSlides[currentSlide].title}
//               </h1>
//               <p className="text-lg sm:text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
//                 {heroSlides[currentSlide].subtitle}
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
//                 <button className="group bg-stone-50 text-stone-900 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base">
//                   <span className="flex items-center gap-2 justify-center">
//                     Explore Portfolio
//                     <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
//                   </span>
//                 </button>
//                 <button className="group border-2 border-stone-50 text-stone-50 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base">
//                   <span className="flex items-center gap-2 justify-center">
//                     <Play className="w-4 h-4 sm:w-5 sm:h-5" />
//                     Watch Video
//                   </span>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Slide Indicators */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
//           {heroSlides.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentSlide(index)}
//               className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                 index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
//               }`}
//             />
//           ))}
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 right-8 animate-bounce">
//           <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-stone-50" />
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="py-16 sm:py-20" style={{backgroundColor: '#f4f1ec'}}>
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 sm:mb-16 gap-4">
//             <div data-animate id="services-title">
//               <h2 
//                 className={`text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 transition-all duration-1000 ${isVisible['services-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 OUR SERVICES
//               </h2>
//             </div>
//             <div data-animate id="services-link">
//               <button className={`text-stone-900 font-semibold text-base sm:text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-all duration-300 ${isVisible['services-link'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//                 BROWSE ALL SERVICES
//               </button>
//             </div>
//           </div>

//           <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
//             {[
//               {
//                 title: "SPACE PLANNING",
//                 description: "Dolor lacinia egestas eros porta natoque magnis phasellus sagittis ultrices felis.",
//                 image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop"
//               },
//               {
//                 title: "FURNITURE SELECTION",
//                 description: "Class hendrerit nulla platea est fillius ut velit eros donec odio ornare dui leo.",
//                 image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop"
//               }
//             ].map((service, index) => (
//               <div 
//                 key={index}
//                 data-animate 
//                 id={`service-card-${index}`}
//                 className={`relative overflow-hidden aspect-[4/3] group transition-all duration-1000 delay-${index * 200} ${isVisible[`service-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//               >
//                 <RevealImage
//                   src={service.image}
//                   alt={service.title}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent"></div>
//                 <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-stone-50">
//                   <h3 
//                     className="text-2xl sm:text-3xl font-bold mb-4"
//                     style={{fontFamily: "'Playfair Display', serif"}}
//                   >
//                     {service.title}
//                   </h3>
//                   <p className="text-stone-200 text-base sm:text-lg leading-relaxed">
//                     {service.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
      
//       {/* Our Process Section */}
//       <section className="py-16 sm:py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
//             {/* Left Column - Title and Contact */}
//             <div data-animate id="process-left">
//               <div className={`transition-all duration-1000 ${isVisible['process-left'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//                 <h2 
//                   className="text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 mb-8 leading-tight"
//                   style={{fontFamily: "'Playfair Display', serif"}}
//                 >
//                   OUR PROCESS
//                 </h2>
//                 <div className="inline-block">
//                   <button className="text-stone-900 font-semibold text-base sm:text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-colors duration-300">
//                     CONTACT US
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right Column - Process Steps */}
//             <div className="space-y-12 sm:space-y-16">
//               {[
//                 {
//                   number: "01.",
//                   title: "DESIGN YOUR VISION BOARD.",
//                   description: "Eget pharetra platea taciti amet egestas phasellus lobortis posuere posuere hendrerit nullam interdum el congue amet risus habitasse magna cursus libero nam cursus platea."
//                 },
//                 {
//                   number: "02.",
//                   title: "STRATEGIZE YOUR SPACE.",
//                   description: "Integer aliquam facilisis porttitor lobortis pharetra arcu. Tellus litorate varius phasellus non ultrices odio blandit morbi. Ex euismod magnis hendrerit sed aliquet velit."
//                 },
//                 {
//                   number: "03.",
//                   title: "ELEVATE YOUR DECOR.",
//                   description: "Aenean malesuada torquent pulvinar mattis elits ipsum scelerisque varius mi in ests Integer aptent lact ultrices penatibus accumsan arcu cursus praesent vitae."
//                 }
//               ].map((step, index) => (
//                 <div 
//                   key={index}
//                   data-animate 
//                   id={`process-step-${index}`}
//                   className={`transition-all duration-1000 delay-${index * 200} ${isVisible[`process-step-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//                 >
//                   <div className="border-b border-stone-300 pb-6 sm:pb-8">
//                     <h3 
//                       className="text-xl sm:text-2xl md:text-3xl font-bold text-stone-900 mb-4"
//                       style={{fontFamily: "'Playfair Display', serif"}}
//                     >
//                       <span className="text-stone-500 mr-4">{step.number}</span>
//                       {step.title}
//                     </h3>
//                     <p className="text-stone-600 leading-relaxed text-base sm:text-lg">
//                       {step.description}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Our Testimonials Section */}
//       <section className="py-16 sm:py-20" style={{backgroundColor: '#f4f1ec'}}>
//         <div className="max-w-7xl mx-auto px-6">
//           <div data-animate id="testimonials-header">
//             <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible['testimonials-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2 
//                 className="text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 mb-6"
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 OUR TESTIMONIALS
//               </h2>
//               <p className="text-lg sm:text-xl text-stone-600 max-w-3xl mx-auto">
//                 Pharetra dapibus phasellus vehicula mauris aliquam tristique placerat magna adipiscing magna netus.
//               </p>
//             </div>
//           </div>

//           <div className="grid lg:grid-cols-3 gap-8 items-start">
//             {/* Left Column - Image */}
//             <div data-animate id="testimonials-image">
//               <div className={`transition-all duration-1000 ${isVisible['testimonials-image'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
//                 <RevealImage
//                   src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=800&fit=crop"
//                   alt="Interior Design"
//                   className="h-[400px] sm:h-[600px]"
//                 />
//               </div>
//             </div>

//             {/* Right Columns - Testimonials */}
//             <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
//               {[
//                 {
//                   quote: "RoomFlow completely transformed our space with creative designs and flawless attention to detail!",
//                   name: "SOPHIE MOORE",
//                   location: "NEW YORK"
//                 },
//                 {
//                   quote: "We couldn't have asked for a better design experience—RoomFlow exceeded all our expectations!",
//                   name: "MILLER EVANS",
//                   location: "LOS ANGELES"
//                 },
//                 {
//                   quote: "Every room designed by RoomFlow feels personalized, beautiful, and incredibly functional.",
//                   name: "JOHN CARTER",
//                   location: "LOS ANGELES"
//                 },
//                 {
//                   quote: "From start to finish, RoomFlow delivered exceptional service and breathtaking designs. Truly the best!",
//                   name: "LILLY GREEN",
//                   location: "NEW YORK"
//                 }
//               ].map((testimonial, index) => (
//                 <div 
//                   key={index}
//                   data-animate 
//                   id={`testimonial-${index}`}
//                   className={`bg-white p-6 sm:p-8 transition-all duration-1000 delay-${index * 150} ${isVisible[`testimonial-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//                 >
//                   <p className="text-stone-700 mb-6 text-base sm:text-lg leading-relaxed">
//                     "{testimonial.quote}"
//                   </p>
//                   <div>
//                     <div className="font-bold text-stone-900 text-sm tracking-wide">
//                       {testimonial.name}
//                     </div>
//                     <div className="text-stone-500 text-sm">
//                       {testimonial.location}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Portfolio Section */}
//       <section id="portfolio" className="py-16 sm:py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-6">
//           <div data-animate id="portfolio-header">
//             <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2 
//                 className="text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 mb-6"
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 Featured Projects
//               </h2>
//               <p className="text-lg sm:text-xl text-stone-600 max-w-3xl mx-auto">
//                 Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
//               </p>
//             </div>
//           </div>

//           <div data-animate id="portfolio-grid">
//             <div className={`grid md:grid-cols-2 gap-6 sm:gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               {portfolio.map((project, index) => (
//                 <div
//                   key={project.id}
//                   className={`group relative overflow-hidden bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
//                   style={{ transitionDelay: `${index * 200}ms` }}
//                 >
//                   <RevealImage
//                     src={project.image}
//                     alt={project.title}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//                   <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
//                     <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
//                       {project.category}
//                     </span>
//                     <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
//                       {project.title}
//                     </h3>
//                     <p className="text-stone-200 mb-4 text-sm sm:text-base">{project.description}</p>
//                     <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
//                       View Project <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-16 sm:py-20 bg-stone-900 text-stone-50">
//         <div className="max-w-7xl mx-auto px-6">
//           <div data-animate id="stats-section">
//             <div className={`grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 transition-all duration-1000 ${isVisible['stats-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               {[
//                 { number: "150+", label: "Projects Completed" },
//                 { number: "50+", label: "Happy Clients" },
//                 { number: "15+", label: "Years Experience" },
//                 { number: "25+", label: "Design Awards" }
//               ].map((stat, index) => (
//                 <div 
//                   key={index} 
//                   className={`text-center fade-up ${isVisible['stats-section'] ? 'visible' : ''}`}
//                   style={{ transitionDelay: `${index * 200}ms` }}
//                 >
//                   <div 
//                     className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2"
//                     style={{fontFamily: "'Playfair Display', serif"}}
//                   >
//                     {stat.number}
//                   </div>
//                   <div className="text-stone-300 font-medium text-sm sm:text-base">{stat.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="relative py-0 overflow-hidden" style={{backgroundColor: '#f4f1ec'}}>
//         <div className="relative h-[500px] sm:h-[600px] md:h-[700px]">
//           {/* Background Image */}
//           <img
//             src="https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1920&h=1080&fit=crop"
//             alt="Bedroom Interior"
//             className="w-full h-full object-cover"
//             loading="lazy"
//           />
//           {/* Stronger dark overlay */}
//           <div className="absolute inset-0 bg-black bg-opacity-60"></div>
          
//           {/* Content */}
//           <div className="relative z-20 h-full flex items-center">
//             <div className="max-w-7xl mx-auto px-6 w-full relative h-full">
//               {/* Main heading */}
//               <div className="max-w-4xl flex items-center h-full">
//                 <h2 
//                   className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight text-white"
//                   style={{
//                     fontFamily: "'Playfair Display', serif",
//                     textShadow: '3px 3px 8px rgba(0,0,0,0.8), 1px 1px 3px rgba(0,0,0,0.9)',
//                     WebkitTextStroke: '1px rgba(0,0,0,0.3)'
//                   }}
//                 >
//                   ARE YOU READY TO<br />
//                   CREATE YOUR NEW SPACE?
//                 </h2>
//               </div>
              
//               {/* Contact button */}
//               <div className="absolute bottom-6 sm:bottom-12 right-6 sm:right-12">
//                 <div 
//                   className="font-semibold text-lg sm:text-xl text-white cursor-pointer transition-all duration-300 hover:scale-105"
//                   style={{
//                     textShadow: '2px 2px 6px rgba(0,0,0,0.8)'
//                   }}
//                 >
//                   <div>CONTACT US</div>
//                   <div className="bg-white h-0.5 mt-2 transition-all duration-300 hover:h-1"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <PremiumFooter/>
//     </div>
//   );
// };

// export default InteriorDesignWebsite;




import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ArrowRight, ChevronDown, Play, Star, Award, Users, Home } from 'lucide-react';
import PremiumFooter from './Footer';
import LivingImage1 from './Images/Living1.webp';
import LivingImage2 from './Images/LIVING.webp';
import image1 from './Images/LIVINGANDPOOJA.webp';
import LivingImage3 from './Images/LIVINGTODINING.webp';
import kitchen1 from './Images/KICTHENV1.webp';
import warddrobe from './Images/MasterBedroomWardrobe1.webp';
import bedroom1 from './Images/BedroomWardrobe2.webp' ;
import living2 from './Images/Living2.webp';
import flooring from './Images/DINING.webp';
import bedroom2 from './Images/MASTER BEDROOM_ (1).webp';
import bedroom3 from './Images/MASTER BEDROOM _V1.webp';
import kitchen2 from './Images/Kitchen,dining and crockery (1).webp';
import bedroom4 from './Images/BEDROOM 3_ (2).webp';
import bedroom5 from './Images/MASTER BEDROOM_ (2).webp';
import bedroom6 from './Images/BEDROOM 3 (4).webp';
import bedroom7 from './Images/Bedroom 3__.webp';
import kitchen4 from './Images/Kitchen_.webp';
import kitchen5 from './Images/KICTHENV1.webp';
import kitchen3 from './Images/Kitchen (2).webp';
import kitchen6 from './Images/CROCKERY_V1 (1).webp';

// Footer Component


// Reusable RevealImage Component - Fixed for proper scroll triggering
const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
  const wrapperRef = useRef();
  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add("revealed");
            observer.unobserve(el);
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
      <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
      <div className="reveal-mask"></div>
    </div>
  );
};

const InteriorDesignWebsite = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [expandedProcess, setExpandedProcess] = useState(0); // Add state for accordion

  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Optimized scroll handler with throttling
  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    // Use passive listeners for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({
              ...prev,
              [entry.target.id]: true
            }));
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '0px 0px -20px 0px'
      }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const heroSlides = [
    {
      // image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&h=1080&fit=crop",
      image:LivingImage1,
      title: "Luxury Living Redefined",
      subtitle: "Crafting extraordinary spaces that inspire and elevate"
    },
    {
      // image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&h=1080&fit=crop",
      image:LivingImage3,
      title: "Modern Sophistication",
      subtitle: "Where contemporary design meets timeless elegance"
    },
    {
      // image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&h=1080&fit=crop",
      image:image1,
      title: "Architectural Excellence",
      subtitle: "Transforming visions into breathtaking realities"
    }
  ];

  // const portfolio = [
  //   {
  //     id: 1,
  //     title: "Manhattan Penthouse",
  //     category: "Residential",
  //     image: bedroom2,
  //     description: "A sophisticated urban retreat with panoramic city views"
  //   },
  //   {
  //     id: 2,
  //     title: "Modern Office Complex",
  //     category: "Commercial",
  //     // image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
  //     image: bedroom3,
  //     description: "Innovative workspace design promoting creativity and collaboration"
  //   },
  //   {
  //     id: 3,
  //     title: "Luxury Resort Suite",
  //     category: "Hospitality",
  //     // image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
  //     image:kitchen2,
  //     description: "Elegant coastal design with natural materials and textures"
  //   },
  //   {
  //     id: 4,
  //     title: "Contemporary Villa",
  //     category: "Residential",
  //     // image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop",
  //     image:image1,
  //     description: "Minimalist luxury with seamless indoor-outdoor living"
  //   }
  // ];
// const portfolio = [
//     {
//       id: 1,
//       title: "Manhattan Penthouse",
//       category: "Residential",
//       images: [bedroom2, bedroom4, bedroom5],
//       description: "A sophisticated urban retreat with panoramic city views"
//     },
//     {
//       id: 2,
//       title: "Modern Office Complex",
//       category: "Commercial",
//       images: [kitchen3, kitchen5, kitchen6],
//       description: "Innovative workspace design promoting creativity and collaboration"
//     },
//     {
//       id: 3,
//       title: "Luxury Resort Suite",
//       category: "Hospitality",
//       images: [LivingImage1,kitchen2,LivingImage2],
//       description: "Elegant coastal design with natural materials and textures"
//     },
//     {
//       id: 4,
//       title: "Contemporary Villa",
//       category: "Residential",
//       images: [bedroom3, bedroom6, bedroom7],
//       description: "Minimalist luxury with seamless indoor-outdoor living"
//     }
//   ];

const portfolio = [
  {
    id: 1,
    title: "Master Bedroom Elegance",
    category: "Interiors",
    images: [bedroom2, bedroom4, bedroom5],
    description: "A serene retreat designed with luxurious finishes, warm lighting, and intelligent layouts for ultimate comfort."
  },
  {
    id: 2,
    title: "Modern Modular Kitchen",
    category: "Kitchen",
    images: [kitchen3, kitchen5, kitchen6],
    description: "A seamless blend of contemporary design and flawless functionality, crafted for style and everyday efficiency."
  },
  {
    id: 3,
    title: "Elegant Living Space",
    category: "Living Room",
    images: [LivingImage1, kitchen2, LivingImage2],
    description: "A sophisticated living area with refined textures, balanced tones, and a welcoming ambiance."
  },
  {
    id: 4,
    title: "Contemporary Guest Bedroom",
    category: "Interiors",
    images: [bedroom3, bedroom6, bedroom7],
    description: "Minimalist aesthetics paired with comfort-driven design to create a calm and inviting guest space."
  }
];


  const [currentSlides, setCurrentSlides] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0
  });

  // Auto-rotate slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlides(prev => ({
        1: (prev[1] + 1) % 3,
        2: (prev[2] + 1) % 3,
        3: (prev[3] + 1) % 3,
        4: (prev[4] + 1) % 3
      }));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen text-stone-800" style={{backgroundColor: '#f4f1ec'}}>
      {/* Load Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      {/* Optimized Global Styles for Smooth Scrolling */}
      <style jsx global>{`
        * {
          box-sizing: border-box;
        }
        
        html {
          scroll-behavior: smooth;
          scroll-padding-top: 80px;
          overflow-x: hidden;
        }
        
        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          text-rendering: optimizeLegibility;
        }
        
        /* Enhanced mobile scrolling */
        body, html {
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: none;
        }
        
        /* Hide scrollbars while maintaining functionality */
        ::-webkit-scrollbar {
          width: 0px;
          height: 0px;
          background: transparent;
        }
        
        body {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        
        /* Optimize rendering performance */
        * {
          -webkit-transform: translateZ(0);
          -moz-transform: translateZ(0);
          -ms-transform: translateZ(0);
          -o-transform: translateZ(0);
          transform: translateZ(0);
        }
        
        /* Smooth transitions */
        *, *::before, *::after {
          transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        /* Performance optimizations for mobile */
        @media (max-width: 768px) {
          * {
            -webkit-transform: none !important;
            transform: none !important;
          }
          
          .parallax-disabled {
            transform: none !important;
          }
        }
        
        /* Reduce motion for users who prefer it */
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
          }
        }
      `}</style>

      {/* Component-specific styles */}
      <style jsx>{`
        /* RevealImage Effects - Exact copy from reference */
        .reveal-wrapper {
          position: relative;
          overflow: hidden;
        }
        
        .reveal-wrapper .reveal-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #f4f1ec;
          transform: translateX(-100%);
          transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          z-index: 2;
        }
        
        .reveal-wrapper.revealed .reveal-mask {
          transform: translateX(100%);
        }
        
        .reveal-wrapper img {
          opacity: 0;
          transform: scale(1.1);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .reveal-wrapper.revealed img {
          opacity: 1;
          transform: scale(1);
        }

        /* Optimized animations */
        .fade-up {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .fade-up.visible {
          opacity: 1;
          transform: translateY(0);
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Mobile-specific optimizations */
      /* Performance optimizations for mobile */
@media (max-width: 768px) {
  .parallax-disabled {
    transform: none !important;
  }
  
  /* Keep reveal effects working on mobile */
  .reveal-wrapper .reveal-mask {
    transform: translateX(-100%) !important;
  }
  
  .reveal-wrapper.revealed .reveal-mask {
    transform: translateX(100%) !important;
  }
}
      `}</style>

      {/* Hero Section */}
      <section id="home" className="relative h-screen overflow-hidden">
        {/* Background Slides */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-1000 ${
              index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"}
            />
            <div className="absolute inset-0 bg-stone-900/40"></div>
          </div>
        ))}

        {/* Content */}
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-stone-50 max-w-4xl mx-auto px-6">
            <div 
              className={`transform transition-all duration-1000 delay-300 ${
                isMobile ? 'mobile-optimized' : ''
              }`}
              style={{
                transform: isMobile ? 'none' : `translateY(${scrollY * 0.2}px)`,
              }}
            >
              <h1 
                className="text-4xl sm:text-6xl md:text-8xl font-bold mb-6 leading-tight opacity-0 animate-[slideUp_1s_ease-out_0.5s_forwards]"
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                {heroSlides[currentSlide].title}
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl mb-8 opacity-0 animate-[slideUp_1s_ease-out_0.8s_forwards] font-light">
                {heroSlides[currentSlide].subtitle}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-[slideUp_1s_ease-out_1.1s_forwards]">
                {/* <button className="group bg-stone-50 text-stone-900 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base">
                  <span className="flex items-center gap-2 justify-center">
                    contact us
                    <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
                  </span>
                </button> */}
                

<Link
  to="/contact"
  className="group bg-stone-50 text-stone-900 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-900 hover:text-stone-50 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base inline-block"
>
  <span className="flex items-center gap-2 justify-center">
    contact us
    <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
  </span>
</Link>

                {/* <button className="group border-2 border-stone-50 text-stone-50 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base">
                  <span className="flex items-center gap-2 justify-center">
                    <Play className="w-4 h-4 sm:w-5 sm:h-5" />
                    Watch Video
                  </span>
                </button> */}
                <button
  onClick={() =>
    window.open(
      'https://www.instagram.com/reel/DLmSGJPMbuE/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
      '_blank'
    )
  }
  className="group border-2 border-stone-50 text-stone-50 px-6 sm:px-8 py-3 rounded-full hover:bg-stone-50 hover:text-stone-900 transition-all duration-500 transform hover:scale-105 font-semibold text-sm sm:text-base"
>
  <span className="flex items-center gap-2 justify-center">
    <Play className="w-4 h-4 sm:w-5 sm:h-5" />
    Watch Video
  </span>
</button>

              </div>
            </div>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'bg-stone-50' : 'bg-stone-50/30'
              }`}
            />
          ))}
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 right-8 animate-bounce">
          <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-stone-50" />
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 sm:py-20" style={{backgroundColor: '#f4f1ec'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 sm:mb-16 gap-4">
            <div data-animate id="services-title">
              <h2 
                className={`text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 transition-all duration-1000 ${isVisible['services-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                OUR SERVICES
              </h2>
            </div>
            <div data-animate id="services-link">
              {/* <button className={`text-stone-900 font-semibold text-base sm:text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-all duration-300 ${isVisible['services-link'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                BROWSE ALL SERVICES
              </button> */}
              <Link
                to="/services"
                className={`inline-block text-stone-900 font-semibold text-base sm:text-lg border-b-2 border-stone-900 pb-1 hover:border-stone-600 transition-all duration-300 ${isVisible['services-link'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              >
                BROWSE ALL SERVICES
              </Link>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
            {[
              {
                title: "MODULAR KITCHENS",
                // description: "Elevate your culinary space with bespoke modular kitchens that blend sophisticated design, flawless functionality, elegant finishes, and intelligent layouts.",
                // image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop"
                image:kitchen1
              },
              {
                title: "MODULAR WARDROBES",
                // description: "Transform your living spaces with bespoke modular wardrobes that blend elegant aesthetics, intelligent storage, premium finishes, and tailored layouts for timeless sophistication and functionality.",
                // image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=600&fit=crop"
                image:bedroom1
              }
            ].map((service, index) => (
              <div 
                key={index}
                data-animate 
                id={`service-card-${index}`}
                className={`relative overflow-hidden aspect-[4/3] group transition-all duration-1000 delay-${index * 200} ${isVisible[`service-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              >
                <RevealImage
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-stone-50">
                  <h3 
                    className="text-2xl sm:text-3xl font-bold mb-4"
                    style={{fontFamily: "'Playfair Display', serif"}}
                  >
                    {service.title}
                  </h3>
                  <p className="text-stone-200 text-base sm:text-lg leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Our Process Section - Accordion Style */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            {/* Left Column - Process Accordion */}
            <div data-animate id="process-left">
              <div className={`transition-all duration-1000 ${isVisible['process-left'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <h2 
                  className="text-4xl sm:text-5xl md:text-6xl font-light text-stone-900 mb-12 leading-tight tracking-wide"
                  style={{fontFamily: "'Playfair Display', serif"}}
                >
                  OUR PROCESS
                </h2>
                
                {/* Process Accordion */}
                <div className="space-y-0">
                  {[
                    {
                      number: "01.",
                      title: "Connect With Your Designer",
                      description: "Meet our expert designers who will understand your lifestyle, taste, and aspirations. This is where your dream home begins"
                    },
                    {
                      number: "02.",
                      title: "Explore Our Design Studio",
                      description: "Walk through inspiring concepts, materials, and 3D visualizations. Together, we’ll shape interiors that reflect your personality and bring comfort with style"
                    },
                    {
                      number: "03.",
                      title: "Get Your Instant Quote",
                      description: "Receive a transparent and tailored estimate instantly—making your planning process simple, smart, and stress-free"
                    }
                  ].map((step, index) => (
                    <div 
                      key={index}
                      className="border-b border-stone-200"
                    >
                      <div className="py-8">
                        <div 
                          className="flex items-center justify-between cursor-pointer"
                          onClick={() => setExpandedProcess(expandedProcess === index ? -1 : index)}
                        >
                          <h3 
                            className="text-2xl sm:text-3xl md:text-4xl font-light text-stone-900 tracking-wide hover:text-stone-600 transition-colors duration-300"
                            style={{fontFamily: "'Playfair Display', serif"}}
                          >
                            <span className="mr-4">{step.number}</span>
                            {step.title}
                          </h3>
                          <div className="ml-4">
                            <ChevronDown 
                              className={`w-6 h-6 text-stone-600 transition-transform duration-300 ${
                                expandedProcess === index ? 'transform rotate-180' : ''
                              }`} 
                            />
                          </div>
                        </div>
                        
                        <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
                          expandedProcess === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                        }`}>
                          <div className="mt-6 pl-12">
                            <p className="text-stone-600 leading-relaxed text-base sm:text-lg max-w-lg">
                              {step.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column - Image */}
            <div data-animate id="process-image">
              <div className={`transition-all duration-1000 delay-300 ${isVisible['process-image'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                <RevealImage
                  src={living2}
                  alt="Design Process Materials"
                  className="h-[500px] sm:h-[600px] lg:h-[700px]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Testimonials Section */}
      <section className="py-16 sm:py-20" style={{backgroundColor: '#f4f1ec'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div data-animate id="testimonials-header">
            <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible['testimonials-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-stone-900 mb-6 tracking-wide"
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                OUR TESTIMONIALS
              </h2>
              <p className="text-lg sm:text-xl text-stone-600 max-w-2xl mx-auto leading-relaxed">
               Hear from our happy clients whose dream spaces came to life with Construct Insides
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-5 gap-8 items-start">
            {/* Left Column - Large Image (2 columns) */}
            <div className="lg:col-span-2" data-animate id="testimonials-image">
              <div className={`transition-all duration-1000 ${isVisible['testimonials-image'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                <RevealImage
                  src={flooring}
                  alt="Interior Design Workspace"
                  className="h-[500px] sm:h-[600px] lg:h-[700px] w-full"
                />
              </div>
            </div>

            {/* Right Columns - Testimonials Grid (3 columns) */}
            <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                {
                  quote: "Construct Insides transformed our home with stunning designs and smart solutions that exceeded our expectations",
                  name: "Kishore (Risinia Skyon)",
                  location: "BACHUPALLY"
                },
                {
                  quote: "They turned my dream home into reality with a design that’s stylish, practical, and perfectly suited for my family",
                  name: "Harika (Auro Pride)",
                  location: "Manikonda"
                },
                {
                  quote: "Our office now reflects our brand beautifully—welcoming, elegant, and executed with true excellence",
                  name: "Shankar Reddy",
                  location: "Kondapur"
                },
                {
                  quote: "Construct Insides delivered an elegant, functional design that brought our vision to life with creativity and care",
                  name: "Kavita",
                  location: "Gachibowli"
                }
              ].map((testimonial, index) => (
                <div 
                  key={index}
                  data-animate 
                  id={`testimonial-${index}`}
                  className={`bg-white p-8 lg:p-10 transition-all duration-1000 delay-${index * 150} ${isVisible[`testimonial-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                >
                  <p className="text-stone-700 mb-8 text-lg leading-relaxed font-light">
                    "{testimonial.quote}"
                  </p>
                  <div>
                    <div className="font-semibold text-stone-900 text-sm tracking-[0.15em] uppercase mb-1">
                      {testimonial.name}
                    </div>
                    <div className="text-stone-500 text-sm tracking-wide uppercase">
                      {testimonial.location}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* Portfolio Section */}
      {/* <section id="portfolio" className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div data-animate id="portfolio-header">
            <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 
                className="text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 mb-6"
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                Featured Projects
              </h2>
              <p className="text-lg sm:text-xl text-stone-600 max-w-3xl mx-auto">
                Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
              </p>
            </div>
          </div>

          <div data-animate id="portfolio-grid">
            <div className={`grid md:grid-cols-2 gap-6 sm:gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              {portfolio.map((project, index) => (
                <div
                  key={project.id}
                  className={`group relative overflow-hidden bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
                  style={{ transitionDelay: `${index * 200}ms` }}
                >
                  <RevealImage
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                    <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
                      {project.category}
                    </span>
                    <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
                      {project.title}
                    </h3>
                    <p className="text-stone-200 mb-4 text-sm sm:text-base">{project.description}</p>
                    <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
                      View Project <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <section id="portfolio" className="py-16 sm:py-20 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <div data-animate id="portfolio-header">
      <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible['portfolio-header'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h2 
          className="text-4xl sm:text-5xl md:text-6xl font-bold text-stone-900 mb-6"
          style={{fontFamily: "'Playfair Display', serif"}}
        >
          Featured Projects
        </h2>
        <p className="text-lg sm:text-xl text-stone-600 max-w-3xl mx-auto">
          Discover our latest masterpieces that showcase innovation, elegance, and attention to detail.
        </p>
      </div>
    </div>

    <div data-animate id="portfolio-grid">
      <div className={`grid md:grid-cols-2 gap-6 sm:gap-8 transition-all duration-1000 delay-300 ${isVisible['portfolio-grid'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {portfolio.map((project, index) => (
          <div
            key={project.id}
            className={`group relative overflow-hidden bg-stone-200 aspect-[4/3] hover:shadow-2xl transition-all duration-700 transform hover:scale-[1.02] fade-up ${isVisible['portfolio-grid'] ? 'visible' : ''}`}
            style={{ transitionDelay: `${index * 200}ms` }}
          >
            {/* Slideshow container */}
            <div className="relative w-full h-full">
              {project.images && project.images.map((img, imgIndex) => (
                <div
                  key={imgIndex}
                  className={`absolute inset-0 transition-opacity duration-1000 ${
                    currentSlides[project.id] === imgIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
                  }`}
                >
                  <RevealImage
                    src={img}
                    alt={`${project.title} - ${imgIndex + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
              ))}
            </div>

            <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-stone-50 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
              <span className="text-sm font-semibold text-stone-300 uppercase tracking-wide">
                {project.category}
              </span>
              <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
                {project.title}
              </h3>
              <p className="text-stone-200 mb-4 text-sm sm:text-base">{project.description}</p>
              {/* <button className="flex items-center gap-2 text-stone-50 hover:gap-4 transition-all duration-300">
                View Project <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

      <section className="py-16 sm:py-20" style={{backgroundColor: '#f5f1eb'}}>
  <div className="max-w-7xl mx-auto px-6">
    <div data-animate id="stats-section">
      <div className={`grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 transition-all duration-1000 ${isVisible['stats-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {[
          { number: "50+", label: "Projects Completed" },
          { number: "50+", label: "Happy Clients" },
          { number: "5+", label: "Years Experience" },
          { number: "50+", label: "Happy clients" }
        ].map((stat, index) => (
          <div 
            key={index} 
            className={`text-center fade-up ${isVisible['stats-section'] ? 'visible' : ''}`}
            style={{ transitionDelay: `${index * 200}ms` }}
          >
            <div 
              className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-stone-800"
              style={{fontFamily: "'Playfair Display', serif"}}
            >
              {stat.number}
            </div>
            <div className="text-stone-600 font-medium text-sm sm:text-base">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

      {/* CTA Section */}
      <section className="relative py-0 overflow-hidden" style={{backgroundColor: '#f4f1ec'}}>
        <div className="relative h-[500px] sm:h-[600px] md:h-[700px]">
          {/* Background Image */}
          <img
            src={warddrobe}
            alt="Interior Design"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Lighter overlay for better text visibility */}
          <div className="absolute inset-0 bg-stone-900/30"></div>
          
          {/* Content */}
          <div className="relative z-20 h-full flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full relative h-full">
              {/* Main heading */}
              <div className="max-w-4xl flex items-center h-full">
                <h2 
                  className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-light leading-tight text-white"
                  style={{
                    fontFamily: "'Playfair Display', serif",
                    textShadow: '2px 2px 4px rgba(0,0,0,0.6)',
                  }}
                >
                  ARE YOU READY TO<br />
                  CREATE YOUR NEW SPACE?
                </h2>
              </div>
              
              {/* Contact button */}
              <div className="absolute bottom-6 sm:bottom-12 right-6 sm:right-12">
                <div 
                  className="font-semibold text-lg sm:text-xl text-white cursor-pointer transition-all duration-300 hover:scale-105"
                  style={{
                    textShadow: '2px 2px 4px rgba(0,0,0,0.6)'
                  }}
                >
                  <div className="tracking-wider">CONTACT US</div>
                  <div className="bg-white h-0.5 mt-2 transition-all duration-300 hover:h-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PremiumFooter/>
    </div>
  );
};

export default InteriorDesignWebsite;